import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import api from "../api";
import { useAlert } from "react-alert";
import { Loader } from "./global/loader";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import userAction from "../redux/users/action";
import { Modal } from "react-bootstrap";
import { Pagination, Stack } from "@mui/material";
import { ReactionsMain } from "./reactionsMain";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Intercom from "@intercom/messenger-js-sdk";
import Slider from "react-slick";
import blofinLogo from "../images/blofin.png";
import mexcLogo from "../images/mexc.png";
import option1Img from "../images/option1Img.png";
import option2Img from "../images/option2Img.png";
import option3Img from "../images/option3Img.png";
import weexIco from "../images/weexIco.png";
import mexcwhiteIco from "../images/mexcwhiteIco.jpeg";
import demoImg1 from "../images/categories-img2.jpg";
import mexcIco from "../images/mexc.png";
import { MdLock } from "react-icons/md";
import { PollsList } from "./modals/pollModal";
import CountdownTimer from "./dashboardComp/liveSessionCard";
import { Challenge } from "./challenge/challenge";
import { DashboardOtpModal } from "./modals/dashboardOtpModal";
import { FaArrowTrendUp } from "react-icons/fa6";
import { FaArrowTrendDown } from "react-icons/fa6";
import { io } from "socket.io-client";
import { TextPopupModal } from "./modals/textPopup";
import { AlertCircleIcon, Lock } from "lucide-react";
import Stepper from "./dashboardComp/progressBar";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

const settings = {
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  speed: 2000,
  autoplaySpeed: 4000,
};

export const UserPost = ({ SubsData }) => {
  const alert = useAlert();
  const userStore = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();
  const { setUser } = userAction;
  const location = useLocation();

  const [loader, setLoader] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [activeNav, setActiveNav] = useState("godzilla");
  const [isSubscription, setIsSubscription] = useState(false);
  const [isPollActive, setIsPollActive] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);

  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const [showOtp, setShowOtp] = useState(false);
  const handleCloseOtp = () => setShowOtp(false);
  const handleShowOtp = () => setShowOtp(true);

  const [activeImg, setActiveImg] = useState("");
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  const getPosts = async () => {
    try {
      let payload = {
        page: page,
        userId: userStore?.users?.user?._id,
      };
      setLoader(true);
      let token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = token;
      const postData = await api.postGet(payload);
      // console.log(postData);
      // setData([...data, ...postData.post]);
      setData(postData.post);

      setnoOfPost(postData.count);
      setLimit(postData.limit);
      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "Something went wrong");
      console.log(error?.message);
      setLoader(false);
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
    var scrollDiv = document.getElementById("cWidget").offsetTop;
    window.scrollTo({ top: scrollDiv, behavior: "smooth" });
  };

  useEffect(() => {
    if (SubsData?.isSubscription) {
      getPosts();
    } else {
      setLoader(false);
    }
  }, [page, SubsData]);

  // const checkUserSession = async () => {
  //   let token = localStorage.getItem("token");
  //   // console.log(token);
  //   if (token) {
  //     let payload = { token: token };
  //     const registerationResponse = await api.verifySession(payload);
  //     // console.log(registerationResponse);
  //     if (registerationResponse?.token) {
  //       axios.defaults.headers.common["Authorization"] =
  //         registerationResponse?.token;
  //       return true;
  //     } else {
  //       dispatch(setUser({}));
  //       localStorage.removeItem("token");
  //       return false;
  //     }
  //   }
  // };

  useEffect(() => {
    if (SubsData?.isSubscription) {
      setIsSubscription(SubsData?.isSubscription);

      // Intercom({
      //   app_id: "u3zetb7y",
      //   user_id: userStore?.users?.user?._id, // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
      //   name: userStore?.users?.user?.name, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
      //   email: userStore?.users?.user?.email, // IMPORTANT: Replace "user.email" with the variable you use to capture  the user's email  created_at: user.createdAt, // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
      // });
      // let iframe = document.querySelector(".intercom-lightweight-app");

      // if (iframe) {
      //   iframe.style.display = "block";
      // }
    }
    return () => {
      // Find and remove the HubSpot iframe
      // let iframe = document.querySelector(".intercom-lightweight-app");
      // if (iframe) {
      //   iframe.style.display = "none";
      // }
    };
  }, [userStore?.users, SubsData]);

  const handleActiveImg = (link) => {
    setActiveImg(link);
    handleShowMore();
  };

  // hubspot chat
  // useEffect(() => {
  //   // Check if the current route is '/dashboard'
  //   if (location.pathname === "/dashboard") {
  //     let iframe = document.querySelector('iframe[src*="hubspot.com"]');
  //     let chatDiv = document.getElementById(
  //       "hubspot-messages-iframe-container"
  //     );
  //     if (iframe) {
  //       iframe.style.display = "block";
  //       chatDiv.style.visibility = "visible";
  //     }
  //     // Dynamically inject the HubSpot chat script
  //     const script = document.createElement("script");
  //     script.src = "https://js-eu1.hs-scripts.com/145919709.js"; // Replace with your HubSpot portal ID
  //     script.async = true;
  //     document.body.appendChild(script);

  //     // Cleanup the script when leaving the /dashboard route
  //     return () => {
  //       // Find and remove the HubSpot iframe
  //       let iframe = document.querySelector('iframe[src*="hubspot.com"]');
  //       let chatDiv = document.getElementById(
  //         "hubspot-messages-iframe-container"
  //       );
  //       if (iframe) {
  //         iframe.style.display = "none";
  //         chatDiv.style.visibility = "hidden";
  //       }
  //       document.body.removeChild(script);
  //     };
  //   }
  // }, [location.pathname]);

  const sendOtpMail = async () => {
    try {
      setLoader(true);
      let payload = {
        email: userStore?.users?.user?.email,
      };
      const resp = await api.sendOtpMailUser(payload);
      if (resp?.success) {
        alert.show(resp?.message);
        handleShowOtp();
      } else {
        alert.show(resp?.message || "Something went wrong");
      }
      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "Something went wrong");
      console.log(error?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (userStore?.users?.user?.email) {
      checkEmailVerified();
    }
  }, [userStore?.users]);

  const checkEmailVerified = async () => {
    try {
      let payload = {
        email: userStore?.users?.user?.email,
      };
      setLoader(true);
      let token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = token;
      const resp = await api.isEmailVerified(payload);
      // console.log(resp);

      if (resp?.success) {
        setIsEmailVerified(true);
      } else {
        setIsEmailVerified(false);
      }
      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "Something went wrong");
      console.log(error?.message);
      setLoader(false);
    }
  };

  // const checkTermsAccepted = async () => {
  //   try {
  //     const resp = await api.checkSubscriptionConsents();
  //     console.log(resp);
  //     if (resp?.termsAccepted) {
  //       setIsTermsAccepted(true);
  //     }
  //   } catch (e) {
  //     console.log(e.message);
  //     setLoader(false);
  //   }
  // };

  // useEffect(() => {
  //   if (userStore?.users?.user?.email && SubsData?.isSubscription) {
  //     checkTermsAccepted();
  //   }
  // }, [userStore, SubsData]);

  return (
    <>
      {loader ? (
        <div className="postBgLoad"></div>
      ) : (
        <div className="container">
          <Stepper SubsData={SubsData} />
          <div className="signalsPage">
            <div className="row">
              <div
                className={
                  isPollActive ? "col-xl-3 order-2 order-xl-1" : "col-12"
                }
              >
                <PollsList
                  userId={userStore?.users?.user?._id}
                  setIsPollActive={setIsPollActive}
                  isPollActive={isPollActive}
                />
              </div>
              <div
                className={
                  isPollActive ? "col-xl-9 order-1 order-xl-2" : "col-12"
                }
              >
                <div className="contact-widget-area pb-70 mt-4" id="cWidget">
                  <div className="contact-widget-area-inner">
                    <div className="">
                      {!isSubscription ? (
                        <>
                          <UnpaidAlert />
                        </>
                      ) : !isEmailVerified ? (
                        <>
                          <NotVerifiedEmail sendOtpMail={sendOtpMail} />
                        </>
                      ) : (
                        // : !isTermsAccepted ? (
                        //   <>
                        //     <TermsComp setIsTermsAccepted={setIsTermsAccepted} />
                        //   </>
                        // )
                        <>
                          {/* <div className="section-title text-center mb-45 mt-4">
                    <span />
                    <h2 className="text-uppercase">waqar zaka updates</h2>
                  </div> */}
                          {/* <div className="joinTelegram mb-2">
                      <a
                        href={process.env.REACT_APP_TELEGRAM_URL}
                        className="themeBtn"
                        target="_blank"
                      >
                        Join Telegram
                      </a>
                    </div> */}
                          <div className="subscriptionNav">
                            <div
                              className={
                                activeNav == "signals" ? "link active" : "link"
                              }
                              onClick={() => setActiveNav("signals")}
                            >
                              Crypto Trades
                            </div>
                            <div
                              className={
                                activeNav == "commodities"
                                  ? "link active"
                                  : "link"
                              }
                              onClick={() => setActiveNav("commodities")}
                            >
                              Stock & Commodities Trades
                            </div>
                            <div
                              className={
                                activeNav == "market" ? "link active" : "link"
                              }
                              onClick={() => setActiveNav("market")}
                            >
                              Market Updates
                            </div>
                            {/* <div
                        className={
                          activeNav == "broadcast" ? "link active" : "link"
                        }
                        onClick={() => setActiveNav("broadcast")}
                      >
                        Broadcast
                      </div> */}
                            <div
                              className={
                                activeNav == "education"
                                  ? "link active"
                                  : "link"
                              }
                              onClick={() => setActiveNav("education")}
                            >
                              Education
                            </div>
                            <div
                              className={
                                activeNav == "session" ? "link active" : "link"
                              }
                              onClick={() => setActiveNav("session")}
                            >
                              Live Session
                            </div>
                            {/* <div
                              className={
                                activeNav == "futures" ? "link active" : "link"
                              }
                              onClick={() => setActiveNav("futures")}
                            >
                              Futures
                            </div> */}
                            {/* <div
                              className={
                                activeNav == "challenge"
                                  ? "link active"
                                  : "link"
                              }
                              onClick={() => setActiveNav("challenge")}
                            >
                              Challenge
                            </div> */}
                            {/* <div
                        className={
                          activeNav == "summary" ? "link active" : "link"
                        }
                        onClick={() => setActiveNav("summary")}
                      >
                        Trade Summary
                      </div> */}
                            {/* <div
                        className={
                          activeNav == "story" ? "link active" : "link"
                        }
                        onClick={() => setActiveNav("story")}
                      >
                        Story
                      </div> */}
                            <div
                              className={
                                activeNav == "godzilla" ? "link active" : "link"
                              }
                              onClick={() => setActiveNav("godzilla")}
                            >
                              Futures
                            </div>
                          </div>
                          {activeNav == "signals" && (
                            <>
                              <div className="userPostSec">
                                {data.length == 0 && !loader && (
                                  <h3 className="text-center mt-4">
                                    No Data Available
                                  </h3>
                                )}

                                <div className="row">
                                  {data.map((item, key) => (
                                    <>
                                      <PostCardComp
                                        item={item}
                                        key={key}
                                        handleActiveImg={handleActiveImg}
                                      />
                                    </>
                                  ))}
                                </div>
                              </div>
                              {/* {limit * page < noOfPost && (
                          <div className="showMoreBtn text-center mt-5">
                            <button
                              className="themeBtn mx-auto"
                              onClick={() => handleChange(page + 1)}
                            >
                              Show More
                            </button>
                          </div>
                        )} */}
                              <div className="d-flex justify-content-center">
                                <Stack spacing={2}>
                                  <Pagination
                                    count={Math.ceil(noOfPost / limit)}
                                    page={page}
                                    onChange={handleChange}
                                  />
                                </Stack>
                              </div>
                            </>
                          )}
                          {activeNav == "commodities" && (
                            <StocksComp handleActiveImg={handleActiveImg} />
                          )}
                          {activeNav == "market" && (
                            <MarketComp handleActiveImg={handleActiveImg} />
                          )}
                          {/* {activeNav == "broadcast" && <BroadCastcomp />} */}
                          {activeNav == "education" && <Videocomp />}
                          {activeNav == "session" && <LiveSessions />}
                          {/* {activeNav == "futures" && <FutureTradesComp />} */}
                          {activeNav == "godzilla" && (
                            <GodzillaComp handleActiveImg={handleActiveImg} />
                          )}
                          {activeNav == "summary" && <SummaryComp />}
                          {/* {activeNav == "challenge" && <Challenge />} */}
                          {/* {activeNav == "story" && <Storycomp />} */}
                        </>
                        // <h2 className="addWalletText">
                        //   This feature is only available for paid users.
                        // </h2>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {loader && <Loader />}

      <Modal size="lg" show={showMore} onHide={handleCloseMore} centered>
        <Modal.Body>
          <div className="otpModalMain broadcastModal">
            <div className="closeIcon" onClick={handleCloseMore}>
              <i className="fa-solid fa-xmark" />
            </div>

            <div className="showMoreModalM">
              <div className="showMoreModal">
                <img className="w-100" src={activeImg} alt="" />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <DashboardOtpModal
        show={showOtp}
        setShow={setShowOtp}
        email={userStore?.users?.user?.email}
      />
    </>
  );
};

const PostCardComp = ({ item, handleActiveImg }) => {
  const userStore = useSelector((state) => state.userReducer);
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const [userReacted, setUserReacted] = useState({});
  const [allReactions, setAllReactions] = useState([]);
  const [reactionCounts, setReactionCounts] = useState({});

  const addReaction = async (reactionType) => {
    try {
      let payload = {
        userId: userStore?.users?.user?._id,
        postId: item?._id,
        reactionType: reactionType,
      };
      if (userReacted?.reactionType == reactionType) {
        console.log("already reacted");
        return;
      }

      const resp = await api.cryptoReactionAdd(payload);
      // console.log(resp);
      if (resp?.reaction?.userId) {
        // getReaction(item?._id);
        // Update the local state to reflect the new reaction count and the user's reaction
        setReactionCounts((prevCounts) => {
          const updatedCounts = { ...prevCounts };
          // If there's an existing reaction, decrement its count
          if (userReacted?.reactionType) {
            updatedCounts[userReacted?.reactionType] = Math.max(
              0,
              updatedCounts[userReacted?.reactionType] - 1,
            );
          }
          // Increment the count for the new reaction type
          updatedCounts[reactionType] = (updatedCounts[reactionType] || 0) + 1;

          return updatedCounts;
        });
        setUserReacted(resp?.reaction);
      }
    } catch (error) {}
  };
  const deleteReaction = async (id, reactionType) => {
    try {
      let payload = {
        id: id,
        reactionType: reactionType,
        postId: item?._id,
      };

      const resp = await api.cryptoReactionDelete(payload);
      // console.log(resp);
      if (resp?.message == "Reaction deleted") {
        // Update the local state to reflect the removed reaction
        setReactionCounts((prevCounts) => {
          const updatedCounts = { ...prevCounts };
          if (updatedCounts[reactionType]) {
            updatedCounts[reactionType] -= 1;
          }
          return updatedCounts;
        });
        setUserReacted({});
        // getReaction(item?._id);
      }
    } catch (error) {
      console.log(error?.message);
    }
  };
  // const getReaction = async (id) => {
  //   try {
  //     let payload = {
  //       postId: id,
  //     };

  //     const resp = await api.cryptoReactionGet(payload);
  //     // console.log(resp);
  //     if (resp?.success) {
  //       setAllReactions(resp?.reactions);
  //     }
  //   } catch (error) {
  //     console.log(error?.message);
  //   }
  // };

  useEffect(() => {
    if (item?.reactionCount) {
      setReactionCounts(item?.reactionCount || {});
    }
  }, []);

  // useEffect(() => {
  //   if (item?._id) {
  //     getReaction(item?._id);
  //   }
  // }, []);

  // ── helpers ────────────────────────────────────────────────────────
  const fmt = (n) =>
    n != null && n !== ""
      ? Number(n).toLocaleString(undefined, { maximumFractionDigits: 8 })
      : null;

  const statusMeta = {
    Open: { cls: "pc-status-open", icon: "🔵" },
    Closed: { cls: "pc-status-closed", icon: "⚪" },
    "TP Hit": { cls: "pc-status-tp", icon: "🟢" },
    "SL Hit": { cls: "pc-status-sl", icon: "🔴" },
  };

  // ── spot trade block ───────────────────────────────────────────────
  const renderSpotTrade = (s) => (
    <div className="pc-trade-block pc-spot">
      <div className="pc-trade-header">
        <div className="pc-trade-header-left">
          <div className="pc-coin-icon">
            <img
              src={`${baseUrl}/icon/${s.coin.toLowerCase().split("/")[0]}.svg`}
              alt={s.coin}
              onError={(e) => handleImageError(e)}
            />
          </div>
          <span className="pc-trade-coin">{s.coin}</span>
          {s.exchange && (
            <span className="pc-trade-exchange">{s.exchange}</span>
          )}
        </div>
        <span className="pc-trade-type-badge pc-spot-badge">SPOT</span>
      </div>

      <div className="pc-trade-divider" />

      <div className="pc-trade-grid">
        <div className="pc-trade-item">
          <span className="pc-trade-label">Entry Price</span>
          <span className="pc-trade-value">${fmt(s.entryPrice)}</span>
        </div>
        <div className="pc-trade-item">
          <span className="pc-trade-label">Take Profit</span>
          <span className="pc-trade-value pc-green">${fmt(s.takeProfit)}</span>
        </div>
        <div className="pc-trade-item">
          <span className="pc-trade-label">Filled (USDT)</span>
          <span className="pc-trade-value">${fmt(s.filledAmountUSDT)}</span>
        </div>
        <div className="pc-trade-item">
          <span className="pc-trade-label">Filled ({s.coin})</span>
          <span className="pc-trade-value">{s.filledQuantityCoin}</span>
        </div>
      </div>
    </div>
  );

  // ── futures trade block ────────────────────────────────────────────
  const renderFuturesTrade = (f) => {
    const meta = statusMeta[f.status] || { cls: "", icon: "⚪" };
    const isLong = f.positionType === "Long";

    return (
      <div className="pc-trade-block pc-futures">
        {/* Header */}
        <div className="pc-trade-header">
          <div className="pc-trade-header-left">
            <div className="pc-coin-icon">
              <img
                src={`${baseUrl}/icon/${f.coin.toLowerCase().split("/")[0]}.svg`}
                alt={f.coin}
                onError={(e) => handleImageError(e)}
              />
            </div>
            <span className="pc-trade-coin">{f.coin}</span>
            {f.exchange && (
              <span className="pc-trade-exchange">{f.exchange}</span>
            )}
          </div>
          <span className="pc-trade-type-badge pc-futures-badge">FUTURES</span>
        </div>

        {/* Position + Status row */}
        <div className="pc-futures-meta">
          <span
            className={`pc-position-badge ${isLong ? "pc-long" : "pc-short"}`}
          >
            {isLong ? "▲ Long" : "▼ Short"}
          </span>
          {f.leverage && (
            <span className="pc-leverage-badge">{f.leverage}x</span>
          )}
          {f.marginMode && (
            <span className="pc-margin-badge">{f.marginMode}</span>
          )}
          {/* <span className={`pc-status-badge ${meta.cls}`}>
            {meta.icon} {f.status}
          </span> */}
        </div>

        <div className="pc-trade-divider" />

        {/* Price grid */}
        <div className="pc-trade-grid">
          <div className="pc-trade-item">
            <span className="pc-trade-label">Entry Price</span>
            <span className="pc-trade-value">${fmt(f.entryPrice)}</span>
          </div>
          <div className="pc-trade-item">
            <span className="pc-trade-label">Stop Loss</span>
            <span className="pc-trade-value pc-red">${fmt(f.stopLoss)}</span>
          </div>
          <div className="pc-trade-item">
            <span className="pc-trade-label">Take Profit</span>
            <span className="pc-trade-value pc-green">
              ${fmt(f.takeProfit)}
            </span>
          </div>
          {f.liquidationPrice && (
            <div className="pc-trade-item">
              <span className="pc-trade-label">Liquidation</span>
              <span className="pc-trade-value pc-red">
                ${fmt(f.liquidationPrice)}
              </span>
            </div>
          )}
          {f.marginUsedUSDT && (
            <div className="pc-trade-item">
              <span className="pc-trade-label">Margin Used</span>
              <span className="pc-trade-value">${fmt(f.marginUsedUSDT)}</span>
            </div>
          )}
          {f.positionSizeUSDT && (
            <div className="pc-trade-item">
              <span className="pc-trade-label">Position Size</span>
              <span className="pc-trade-value">${fmt(f.positionSizeUSDT)}</span>
            </div>
          )}
        </div>

        {/* PNL / ROI — only show when trade is closed */}
        {/* {(f.pnlUSDT != null || f.roiPercent != null) && (
          <>
            <div className="pc-trade-divider" />
            <div className="pc-pnl-row">
              {f.pnlUSDT != null && (
                <div className="pc-pnl-item">
                  <span className="pc-trade-label">PNL</span>
                  <span
                    className={`pc-pnl-value ${f.pnlUSDT >= 0 ? "pc-green" : "pc-red"}`}
                  >
                    {f.pnlUSDT >= 0 ? "+" : ""}
                    {fmt(f.pnlUSDT)} USDT
                  </span>
                </div>
              )}
              {f.roiPercent != null && (
                <div className="pc-pnl-item">
                  <span className="pc-trade-label">ROI</span>
                  <span
                    className={`pc-pnl-value ${f.roiPercent >= 0 ? "pc-green" : "pc-red"}`}
                  >
                    {f.roiPercent >= 0 ? "+" : ""}
                    {f.roiPercent}%
                  </span>
                </div>
              )}
            </div>
          </>
        )} */}
      </div>
    );
  };
  const handleImageError = (event) => {
    event.target.src = `${baseUrl}/icon-not-found.png`;
    event.target.onerror = null;
    event.target.alt = "Not Found";
  };

  return (
    <div className="col-md-6 mb-3">
      <div className="postCard">
        {item?.imageTitle && (
          <>
            {item.imageTitle.split(",").length > 1 ? (
              <Slider {...settings}>
                {item.imageTitle.split(",").map((val, key) => (
                  <div>
                    <div
                      className="imgDiv"
                      onClick={() =>
                        handleActiveImg(
                          `${process.env.REACT_APP_S3URL}/img_${val}.${
                            item.imageFormat.split(",")[key]
                          }`,
                        )
                      }
                    >
                      <img
                        src={`${process.env.REACT_APP_S3URL}/img_${val}.${
                          item.imageFormat.split(",")[key]
                        }`}
                        alt=""
                      />
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <>
                {item.imageTitle.split(",").map((val, key) => (
                  <div
                    className="imgDiv"
                    onClick={() =>
                      handleActiveImg(
                        `${process.env.REACT_APP_S3URL}/img_${val}.${
                          item.imageFormat.split(",")[key]
                        }`,
                      )
                    }
                  >
                    <img
                      src={`${process.env.REACT_APP_S3URL}/img_${val}.${
                        item.imageFormat.split(",")[key]
                      }`}
                      alt=""
                    />
                  </div>
                ))}
              </>
            )}
          </>
        )}
        {item?.video && (
          <div className="py-2 iVideoPost">
            <div
              dangerouslySetInnerHTML={{
                __html: item?.video,
              }}
            />
          </div>
        )}
        {item?.pdfFile && (
          <div>
            <a
              href={`${process.env.REACT_APP_S3URL}/${item?.pdfFile}`}
              download={item?.pdfFile.split("_")[0]}
              target="_blank"
              className="fileAttachCard my-2"
            >
              <span className="fileAttachIcon">
                {item?.pdfFile.includes(".pdf") ? (
                  <i
                    className="fa-solid fa-file-pdf"
                    style={{ color: "#e53935" }}
                  />
                ) : item?.pdfFile.includes(".xlsx") ||
                  item?.pdfFile.includes(".xls") ? (
                  <i
                    className="fa-solid fa-file-excel"
                    style={{ color: "#1d6f42" }}
                  />
                ) : (
                  <i
                    className="fas fa-file-word"
                    style={{ color: "#1565c0" }}
                  />
                )}
              </span>
              <span className="fileAttachName">
                {item?.pdfFile.split("_")[0]}
              </span>
            </a>
          </div>
        )}
        {/* ── NEW: Trade Details Block ── */}
        {item?.tradeType === "spot" &&
          item?.spotTrade &&
          renderSpotTrade(item.spotTrade)}
        {item?.tradeType === "futures" &&
          item?.futuresTrade &&
          renderFuturesTrade(item.futuresTrade)}

        <div className="desc">
          <div
            dangerouslySetInnerHTML={{
              __html: item?.description,
            }}
          />
          <div className="date"> {moment(item?.createdAt).fromNow()}</div>
        </div>
        {/* <ReactionsMain
          post={item}
          addReaction={addReaction}
          deleteReaction={deleteReaction}
          setUserReacted={setUserReacted}
          userReacted={userReacted}
        />
        <div className="statesRow">
          <div className="statsR">
            {Object.keys(reactionCounts).map(
              (reactionType) =>
                reactionCounts[reactionType] > 0 && (
                  <div className="stats">
                    {reactionType == "like" ||
                    reactionType == "love" ||
                    reactionType == "sad" ? (
                      <img
                        src={`${baseUrl}/emogis/${reactionType}.png`}
                        alt="icon"
                      />
                    ) : (
                      <img
                        src={`https://flagcdn.com/w20/${reactionType.toLowerCase()}.png`}
                        alt="icon"
                      />
                    )}
                    {reactionCounts[reactionType]}
                  </div>
                )
            )}
          </div>
          <div className="date"> {moment(item?.createdAt).fromNow()}</div>
        </div> */}
      </div>
    </div>
  );
};
const StockCardComp = ({ item, key, handleActiveImg }) => {
  const userStore = useSelector((state) => state.userReducer);
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const fmt = (n) =>
    n != null && n !== ""
      ? Number(n).toLocaleString(undefined, { maximumFractionDigits: 8 })
      : null;

  const renderStockTrade = (trade, tradeType) => {
    const isStock = tradeType === "stock";
    const statusColor =
      trade.status === "Open" || trade.status === "OPEN"
        ? "#16a34a"
        : trade.status === "TP Hit"
          ? "#2563eb"
          : trade.status === "SL Hit"
            ? "#dc2626"
            : "#6b7280";

    return (
      <div className={`pc-trade-block ${isStock ? "pc-spot" : "pc-futures"}`}>
        <div className="pc-trade-header">
          <div className="pc-trade-header-left">
            <span className="pc-trade-coin">{trade.currency || "—"}</span>
          </div>
          <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
            <span
              className="pc-trade-type-badge"
              style={{
                background: isStock ? "#16a34a" : "#2563eb",
                color: "#fff",
              }}
            >
              {tradeType.toUpperCase()}
            </span>
            {trade.status && (
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  padding: "2px 8px",
                  borderRadius: 999,
                  background: `${statusColor}20`,
                  color: statusColor,
                  border: `1px solid ${statusColor}50`,
                }}
              >
                {trade.status}
              </span>
            )}
          </div>
        </div>

        <div className="pc-trade-divider" />

        <div className="pc-trade-grid">
          {fmt(trade.entryPrice) && (
            <div className="pc-trade-item">
              <span className="pc-trade-label">Entry Price</span>
              <span className="pc-trade-value">${fmt(trade.entryPrice)}</span>
            </div>
          )}
          {fmt(trade.takeProfit) && (
            <div className="pc-trade-item">
              <span className="pc-trade-label">Take Profit</span>
              <span className="pc-trade-value pc-green">
                ${fmt(trade.takeProfit)}
              </span>
            </div>
          )}
          {fmt(trade.stopLoss) && (
            <div className="pc-trade-item">
              <span className="pc-trade-label">Stop Loss</span>
              <span className="pc-trade-value pc-red">
                ${fmt(trade.stopLoss)}
              </span>
            </div>
          )}
          {trade.pnlUSDT != null && (
            <div className="pc-trade-item">
              <span className="pc-trade-label">PNL (USDT)</span>
              <span
                className={`pc-trade-value ${
                  trade.pnlUSDT >= 0 ? "pc-green" : "pc-red"
                }`}
              >
                {trade.pnlUSDT >= 0 ? "+" : ""}
                {fmt(trade.pnlUSDT)}
              </span>
            </div>
          )}
          {trade.roiPercent != null && (
            <div className="pc-trade-item">
              <span className="pc-trade-label">ROI</span>
              <span
                className={`pc-trade-value ${
                  trade.roiPercent >= 0 ? "pc-green" : "pc-red"
                }`}
              >
                {trade.roiPercent >= 0 ? "+" : ""}
                {trade.roiPercent}%
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  const [userReacted, setUserReacted] = useState({});
  const [allReactions, setAllReactions] = useState([]);
  const [reactionCounts, setReactionCounts] = useState({});

  const addReaction = async (reactionType) => {
    try {
      let payload = {
        userId: userStore?.users?.user?._id,
        postId: item?._id,
        reactionType: reactionType,
      };
      if (userReacted?.reactionType == reactionType) {
        console.log("already reacted");
        return;
      }

      const resp = await api.stockReactionAdd(payload);
      // console.log(resp);
      if (resp?.reaction?.userId) {
        // getReaction(item?._id);
        // Update the local state to reflect the new reaction count and the user's reaction
        setReactionCounts((prevCounts) => {
          const updatedCounts = { ...prevCounts };
          // If there's an existing reaction, decrement its count
          if (userReacted?.reactionType) {
            updatedCounts[userReacted?.reactionType] = Math.max(
              0,
              updatedCounts[userReacted?.reactionType] - 1,
            );
          }
          // Increment the count for the new reaction type
          updatedCounts[reactionType] = (updatedCounts[reactionType] || 0) + 1;

          return updatedCounts;
        });
        setUserReacted(resp?.reaction);
      }
    } catch (error) {}
  };
  const deleteReaction = async (id, reactionType) => {
    try {
      let payload = {
        id: id,
        reactionType: reactionType,
        postId: item?._id,
      };
      console.log(payload);

      const resp = await api.stockReactionDelete(payload);
      // console.log(resp);
      if (resp?.message == "Reaction deleted") {
        // Update the local state to reflect the removed reaction
        setReactionCounts((prevCounts) => {
          const updatedCounts = { ...prevCounts };
          if (updatedCounts[reactionType]) {
            updatedCounts[reactionType] -= 1;
          }
          return updatedCounts;
        });
        setUserReacted({});
        // getReaction(item?._id);
      }
    } catch (error) {
      console.log(error?.message);
    }
  };

  useEffect(() => {
    if (item?.reactionCount) {
      setReactionCounts(item?.reactionCount || {});
    }
  }, []);

  return (
    <div className="col-md-6 mb-3" key={key}>
      <div className="postCard">
        {item?.imageTitle && (
          <>
            {item.imageTitle.split(",").length > 1 ? (
              <Slider {...settings}>
                {item.imageTitle.split(",").map((val, key) => (
                  <div>
                    <div
                      className="imgDiv"
                      onClick={() =>
                        handleActiveImg(
                          `${process.env.REACT_APP_S3URL}/img_${val}.${
                            item.imageFormat.split(",")[key]
                          }`,
                        )
                      }
                    >
                      <img
                        src={`${process.env.REACT_APP_S3URL}/img_${val}.${
                          item.imageFormat.split(",")[key]
                        }`}
                        alt=""
                      />
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <>
                {item.imageTitle.split(",").map((val, key) => (
                  <div
                    className="imgDiv"
                    onClick={() =>
                      handleActiveImg(
                        `${process.env.REACT_APP_S3URL}/img_${val}.${
                          item.imageFormat.split(",")[key]
                        }`,
                      )
                    }
                  >
                    <img
                      src={`${process.env.REACT_APP_S3URL}/img_${val}.${
                        item.imageFormat.split(",")[key]
                      }`}
                      alt=""
                    />
                  </div>
                ))}
              </>
            )}
          </>
        )}
        {item?.video && (
          <div className="py-2 iVideoPost">
            <div
              dangerouslySetInnerHTML={{
                __html: item?.video,
              }}
            />
          </div>
        )}
        {item?.pdfFile && (
          <div>
            <a
              href={`${process.env.REACT_APP_S3URL}/${item?.pdfFile}`}
              download={item?.pdfFile.split("_")[0]}
              target="_blank"
              className="fileAttachCard my-2"
            >
              <span className="fileAttachIcon">
                {item?.pdfFile.includes(".pdf") ? (
                  <i
                    className="fa-solid fa-file-pdf"
                    style={{ color: "#e53935" }}
                  />
                ) : item?.pdfFile.includes(".xlsx") ||
                  item?.pdfFile.includes(".xls") ? (
                  <i
                    className="fa-solid fa-file-excel"
                    style={{ color: "#1d6f42" }}
                  />
                ) : (
                  <i
                    className="fas fa-file-word"
                    style={{ color: "#1565c0" }}
                  />
                )}
              </span>
              <span className="fileAttachName">
                {item?.pdfFile.split("_")[0]}
              </span>
            </a>
          </div>
        )}
        {item?.tradeType === "stock" &&
          item?.stockTrade &&
          renderStockTrade(item.stockTrade, "stock")}
        {item?.tradeType === "forex" &&
          item?.forexTrade &&
          renderStockTrade(item.forexTrade, "forex")}
        <div className="desc">
          <div
            dangerouslySetInnerHTML={{
              __html: item?.description,
            }}
          />
          <div className="date"> {moment(item?.createdAt).fromNow()}</div>
        </div>
        {/* <ReactionsMain
          post={item}
          addReaction={addReaction}
          deleteReaction={deleteReaction}
          // getReaction={getReaction}
          setUserReacted={setUserReacted}
          userReacted={userReacted}
        />
        <div className="statesRow">
          <div className="statsR">
            {Object.keys(reactionCounts).map(
              (reactionType) =>
                reactionCounts[reactionType] > 0 && (
                  <div className="stats">
                    {reactionType == "like" ||
                    reactionType == "love" ||
                    reactionType == "sad" ? (
                      <img
                        src={`${baseUrl}/emogis/${reactionType}.png`}
                        alt="icon"
                      />
                    ) : (
                      <img
                        src={`https://flagcdn.com/w20/${reactionType.toLowerCase()}.png`}
                        alt="icon"
                      />
                    )}
                    {reactionCounts[reactionType]}
                  </div>
                )
            )}
          </div>
          <div className="date"> {moment(item?.createdAt).fromNow()}</div>
        </div> */}
      </div>
    </div>
  );
};

const BroadCastcomp = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);
  const alert = useAlert();

  const getPosts = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const postData = await api.broadcastGet(payload);
      // console.log(postData);
      // setData([...data, ...postData.broadcast]);
      setData(postData.broadcast);

      setnoOfPost(postData.count);
      setLimit(postData.limit);
      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "Something went wrong");
      console.log(error?.message);
      setLoader(false);
    }
  };
  const handleChange = (event, value) => {
    setPage(value);
    var scrollDiv = document.getElementById("cWidget").offsetTop;
    window.scrollTo({ top: scrollDiv, behavior: "smooth" });
  };
  useEffect(() => {
    getPosts();
  }, [page]);

  return (
    <div className="broadcastMain">
      {data.map((item, key) => (
        <div className="masgM" key={key}>
          <div className="date">{moment(item?.createdAt).fromNow()}</div>
          {item?.description && (
            <div className="msg">
              <div
                dangerouslySetInnerHTML={{
                  __html: item?.description,
                }}
              />
            </div>
          )}
          {item?.voice && (
            <div className="audio">
              <audio controls controlsList="nodownload">
                <source
                  src={`${process.env.REACT_APP_S3URLVoice}/${item.voice}`}
                />
                Audio element not supported by your browser.
              </audio>
            </div>
          )}
        </div>
      ))}
      {/* {limit * page < noOfPost && (
        <div className="showMoreBtn text-center mt-5">
          <button className="themeBtn" onClick={() => handleChange(page + 1)}>
            Show More
          </button>
        </div>
      )} */}
      <div className="d-flex justify-content-center">
        <Stack spacing={2}>
          <Pagination
            count={Math.ceil(noOfPost / limit)}
            page={page}
            onChange={handleChange}
          />
        </Stack>
      </div>
    </div>
  );
};

const Videocomp = () => {
  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);
  const [selectedTab, setSelectedTab] = useState("beginner");

  const getPosts = async () => {
    try {
      let payload = {
        page: page,
        category: selectedTab,
        userId: userStore?.users?.user?._id,
      };
      setLoader(true);
      const postData = await api.videoGet(payload);
      // console.log(postData);
      // setData([...data, ...postData.video]);
      setData(postData.video);
      setnoOfPost(postData.count);
      setLimit(postData.limit);
      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "Something went wrong");
      console.log(error?.message);
      setLoader(false);
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
    var scrollDiv = document.getElementById("cWidget").offsetTop;
    window.scrollTo({ top: scrollDiv, behavior: "smooth" });
  };
  useEffect(() => {
    getPosts();
  }, [page]);

  useEffect(() => {
    // setPage(1);
    if (page == 1) {
      getPosts();
    } else {
      setPage(1);
    }
  }, [selectedTab]);

  return (
    <div className="broadcastMain">
      <div className="vTabs">
        <button
          className={selectedTab == "beginner" ? "active" : ""}
          onClick={() => setSelectedTab("beginner")}
        >
          Beginner
        </button>
        <button
          className={selectedTab == "advance" ? "active" : ""}
          onClick={() => setSelectedTab("advance")}
        >
          Advance
        </button>
        <button
          className={selectedTab === "exclusive" ? "active" : ""}
          onClick={() => setSelectedTab("exclusive")}
        >
          Exclusive
        </button>
      </div>
      {selectedTab === "exclusive" ? (
        <div className="text-center py-5 mt-4">
          <Lock size={64} color="#000" strokeWidth={1.5} />
          <h4
            style={{
              color: "#895aef",
              fontWeight: 700,
              letterSpacing: 1,
              marginTop: 16,
            }}
          >
            COMING SOON
          </h4>
          <p style={{ color: "#888", fontSize: 14 }}>
            Annual Group lessons will be available soon.
            <br />
            Stay tuned.
          </p>
        </div>
      ) : (
        <>
          {data.map((item, key) => (
            <PostCardVideo item={item} key={key} />
          ))}
          <div className="d-flex justify-content-center">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfPost / limit)}
                page={page}
                onChange={handleChange}
              />
            </Stack>
          </div>
        </>
      )}
    </div>
  );
};

const LiveSessions = () => {
  const [activeTab, setActiveTab] = useState("sessions");

  return (
    <div className="broadcastMain">
      <div className="vTabs">
        <button
          className={activeTab === "sessions" ? "active" : ""}
          onClick={() => setActiveTab("sessions")}
        >
          Sessions
        </button>
        <button
          className={activeTab === "trades" ? "active" : ""}
          onClick={() => setActiveTab("trades")}
        >
          Live Trades
        </button>
      </div>
      {activeTab === "sessions" && <LiveSessionsContent />}
      {activeTab === "trades" && <LiveSessionTradesComp />}
    </div>
  );
};

const LiveSessionsContent = () => {
  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);

  const getPosts = async () => {
    try {
      let payload = {
        page: page,
        userId: userStore?.users?.user?._id,
      };
      setLoader(true);
      const postData = await api.liveSessionGet(payload);
      setData(postData.sessions);
      setnoOfPost(postData.count);
      setLimit(postData.limit);
      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "Something went wrong");
      console.log(error?.message);
      setLoader(false);
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
    var scrollDiv = document.getElementById("cWidget").offsetTop;
    window.scrollTo({ top: scrollDiv, behavior: "smooth" });
  };
  useEffect(() => {
    getPosts();
  }, [page]);

  return (
    <>
      {data.length == 0 && !loader && (
        <div className="noLive">
          <h3>
            <i className="fa-solid fa-circle-minus"></i>No Live Session Right
            Now
          </h3>
          <h6 className="mb-2">Live Session – Updated Schedule</h6>
          <h6>New Timings:</h6>
          <ul>
            <li>6:30 PM PKT</li>
            <li>9:00 PM PKT</li>
          </ul>
          <div>
            <b>Days</b>: Monday to Friday
          </div>
          <div>No Live Sessions on Saturday & Sunday</div>
          <div className="note">
            Thank you for your continued support and for being part of our
            community. Stay tuned and join us at the updated times for exciting
            live sessions.
          </div>
        </div>
      )}
      {data.length > 0 && (
        <>
          <div className="notice mb-4 mt-2 px-2">
            <h3>📢 New Live Session Update</h3>
            <div className="mb-2">
              Our new live session timings have been updated:
            </div>
            <div className="w-max m-auto">
              <b>New Timings:</b>
              <ul>
                <li>09:30 PM PKT</li>
                <li>10:30 PM PKT</li>
              </ul>
            </div>
            <div className="mb-2">
              <b>Days</b>: Monday to Friday
            </div>
            <div className="mb-2">
              <b>Saturday</b>: <br /> We’re pleased to announce that live
              sessions will now also be held on Saturdays at 8:30 PM and 10:00
              PM join us to stay updated and connected.
            </div>
            <div>Please note: Sunday – No session.</div>
            <div>Thank you for staying with us!</div>
          </div>

          {data.map((item, key) => (
            <LiveSessionLinkCard item={item} key={key} sessionData={data} />
          ))}
          <div className="d-flex justify-content-center">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfPost / limit)}
                page={page}
                onChange={handleChange}
              />
            </Stack>
          </div>
        </>
      )}
      {loader && <Loader />}
    </>
  );
};

const LiveSessionTradesComp = () => {
  const alert = useAlert();
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [trades, setTrades] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);

  const fmt = (n) =>
    n != null && n !== ""
      ? Number(n).toLocaleString(undefined, { maximumFractionDigits: 8 })
      : null;

  const fetchTrades = async (p = 1) => {
    try {
      setLoader(true);
      const res = await api.liveSessionTradeGetUser({ page: p });
      if (res?.success) {
        setTrades(res.trades);
        setnoOfPost(res.count);
        setLimit(res.limit);
      }
    } catch (error) {
      alert.show(error?.message || "Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchTrades(page);
  }, [page]);

  const handleChange = (event, value) => {
    setPage(value);
    var scrollDiv = document.getElementById("cWidget").offsetTop;
    window.scrollTo({ top: scrollDiv, behavior: "smooth" });
  };

  if (loader) return <Loader />;

  if (trades.length === 0) {
    return (
      <div className="text-center py-5 text-muted">
        <h3>No Live Session Trades Yet</h3>
      </div>
    );
  }

  return (
    <>
      <div className="userPostSec">
        <div className="row">
          {trades.map((t, i) => {
            const isSpot = t.tradeType === "spot";
            const isFutures = t.tradeType === "futures";
            const d = isSpot ? t.spotTrade : isFutures ? t.futuresTrade : null;
            const isLong = d?.positionType === "Long";
            const imgNames = t.imageTitle ? t.imageTitle.split(",") : [];
            const imgFormats = t.imageFormat ? t.imageFormat.split(",") : [];

            return (
              <div className="col-md-6 mb-3 d-flex" key={t._id || i}>
                <div
                  className="postCard w-100"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  {d && (
                    <div
                      className={`pc-trade-block ${isSpot ? "pc-spot" : "pc-futures"}`}
                    >
                      <div className="pc-trade-header">
                        <div className="pc-trade-header-left">
                          <div className="pc-coin-icon">
                            <img
                              src={`${baseUrl}/icon/${d.coin.toLowerCase().split("/")[0]}.svg`}
                              alt={d.coin}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          </div>
                          <span className="pc-trade-coin">{d.coin}</span>
                          {d.exchange && (
                            <span className="pc-trade-exchange">
                              {d.exchange}
                            </span>
                          )}
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <span
                            className={`pc-trade-type-badge ${isSpot ? "pc-spot-badge" : "pc-futures-badge"}`}
                          >
                            {isSpot ? "SPOT" : "FUTURES"}
                          </span>
                          {d.status && d.status !== "Open" && (
                            <span
                              className={
                                d.status === "TP Hit"
                                  ? "badge bg-primary"
                                  : d.status === "SL Hit"
                                    ? "badge bg-danger"
                                    : "badge bg-secondary"
                              }
                              style={{ fontSize: 11, borderRadius: 6 }}
                            >
                              {d.status}
                            </span>
                          )}
                        </div>
                      </div>

                      {isFutures && (
                        <div className="pc-futures-meta">
                          <span
                            className={`pc-position-badge ${isLong ? "pc-long" : "pc-short"}`}
                          >
                            {isLong ? "▲ Long" : "▼ Short"}
                          </span>
                          {d.leverage && (
                            <span className="pc-leverage-badge">
                              {d.leverage}x
                            </span>
                          )}
                          {d.marginMode && (
                            <span className="pc-margin-badge">
                              {d.marginMode}
                            </span>
                          )}
                        </div>
                      )}

                      <div className="pc-trade-divider" />

                      <div className="pc-trade-grid">
                        <div className="pc-trade-item">
                          <span className="pc-trade-label">Entry Price</span>
                          <span className="pc-trade-value">
                            ${fmt(d.entryPrice)}
                          </span>
                        </div>
                        {isFutures && d.stopLoss && (
                          <div className="pc-trade-item">
                            <span className="pc-trade-label">Stop Loss</span>
                            <span className="pc-trade-value pc-red">
                              ${fmt(d.stopLoss)}
                            </span>
                          </div>
                        )}
                        <div className="pc-trade-item">
                          <span className="pc-trade-label">Take Profit</span>
                          <span className="pc-trade-value pc-green">
                            ${fmt(d.takeProfit)}
                          </span>
                        </div>
                        {isSpot && d.filledAmountUSDT && (
                          <div className="pc-trade-item">
                            <span className="pc-trade-label">
                              Filled (USDT)
                            </span>
                            <span className="pc-trade-value">
                              ${fmt(d.filledAmountUSDT)}
                            </span>
                          </div>
                        )}
                        {isSpot && d.filledQuantityCoin && (
                          <div className="pc-trade-item">
                            <span className="pc-trade-label">
                              Filled ({d.coin})
                            </span>
                            <span className="pc-trade-value">
                              {d.filledQuantityCoin}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {imgNames.length > 0 && (
                    <div style={{ padding: "10px 0 4px" }}>
                      {imgNames.map((n, idx) => (
                        <img
                          key={idx}
                          src={`${process.env.REACT_APP_S3URL}/img_${n}.${imgFormats[idx]}`}
                          alt="update"
                          style={{
                            width: "100%",
                            borderRadius: 8,
                            marginBottom: 6,
                            objectFit: "cover",
                          }}
                        />
                      ))}
                    </div>
                  )}

                  <div
                    className="desc"
                    style={{ marginTop: d || imgNames.length > 0 ? "auto" : 0 }}
                  >
                    {t.description && (
                      <div style={{ whiteSpace: "pre-wrap" }}>
                        {t.description}
                      </div>
                    )}
                    <div className="date">{moment(t.createdAt).fromNow()}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {noOfPost > limit && (
        <div className="d-flex justify-content-center">
          <Stack spacing={2}>
            <Pagination
              count={Math.ceil(noOfPost / limit)}
              page={page}
              onChange={handleChange}
            />
          </Stack>
        </div>
      )}
    </>
  );
};

const FutureTradesComp = () => {
  const alert = useAlert();
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [trades, setTrades] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);

  const fmt = (n) =>
    n != null && n !== ""
      ? Number(n).toLocaleString(undefined, { maximumFractionDigits: 8 })
      : null;

  const fetchTrades = async (p = 1) => {
    try {
      setLoader(true);
      const res = await api.futureTradeGetUser({ page: p });
      if (res?.success) {
        setTrades(res.trades);
        setnoOfPost(res.count);
        setLimit(res.limit);
      }
    } catch (error) {
      alert.show(error?.message || "Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchTrades(page);
  }, [page]);

  const handleChange = (event, value) => {
    setPage(value);
    var scrollDiv = document.getElementById("cWidget").offsetTop;
    window.scrollTo({ top: scrollDiv, behavior: "smooth" });
  };

  if (loader) return <Loader />;

  if (trades.length === 0) {
    return (
      <div className="text-center py-5 text-muted">
        <h3>No Futures Trades Yet</h3>
      </div>
    );
  }

  return (
    <div className="userPostSec">
      <div className="row">
        {trades.map((t, i) => {
          const isLong = t.position === "LONG";
          const isClosed = t.status === "CLOSED";

          return (
            <div className="col-md-6 mb-3 d-flex" key={t._id || i}>
              <div
                className="postCard w-100"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div className="pc-trade-block pc-futures">
                  {/* Header */}
                  <div className="pc-trade-header">
                    <div className="pc-trade-header-left">
                      <div className="pc-coin-icon">
                        <img
                          src={`${baseUrl}/icon/${(t.coin || "").toLowerCase()}.svg`}
                          alt={t.coin}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      </div>
                      <span className="pc-trade-coin">{t.coin || "—"}</span>
                      {t.leverage && (
                        <span className="pc-leverage-badge">{t.leverage}x</span>
                      )}
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <span className="pc-trade-type-badge pc-futures-badge">
                        FUTURES
                      </span>
                      <span
                        className={`badge ${isClosed ? "bg-secondary" : "bg-success"}`}
                        style={{ fontSize: 11, borderRadius: 6 }}
                      >
                        {t.status || "OPEN"}
                      </span>
                    </div>
                  </div>

                  {/* Position + R:R status */}
                  {t.position && (
                    <div className="pc-futures-meta">
                      <span
                        className={`pc-position-badge ${isLong ? "pc-long" : "pc-short"}`}
                      >
                        {isLong ? "▲ LONG" : "▼ SHORT"}
                      </span>
                      {t.rr_status && (
                        <span
                          className={`pc-margin-badge ${t.rr_status === "APPROVE" ? "pc-green" : t.rr_status === "REJECT" ? "pc-red" : ""}`}
                        >
                          R:R {t.rr_status}
                        </span>
                      )}
                    </div>
                  )}

                  <div className="pc-trade-divider" />

                  {/* Price grid */}
                  <div className="pc-trade-grid">
                    {t.entryPrice != null && (
                      <div className="pc-trade-item">
                        <span className="pc-trade-label">Entry Price</span>
                        <span className="pc-trade-value">
                          ${fmt(t.entryPrice)}
                        </span>
                      </div>
                    )}
                    {t.targetPrice != null && (
                      <div className="pc-trade-item">
                        <span className="pc-trade-label">Target Price</span>
                        <span className="pc-trade-value pc-green">
                          ${fmt(t.targetPrice)}
                        </span>
                      </div>
                    )}
                    {t.stopLoss != null && (
                      <div className="pc-trade-item">
                        <span className="pc-trade-label">Stop Loss</span>
                        <span className="pc-trade-value pc-red">
                          ${fmt(t.stopLoss)}
                        </span>
                      </div>
                    )}
                    {t.rr != null && (
                      <div className="pc-trade-item">
                        <span className="pc-trade-label">R:R Ratio</span>
                        <span className="pc-trade-value">{t.rr}</span>
                      </div>
                    )}
                  </div>

                  {/* PNL row — only when closed */}
                  {isClosed && (t.pnl != null || t.pnlPercent != null) && (
                    <>
                      <div className="pc-trade-divider" />
                      <div className="pc-pnl-row">
                        {t.closedPrice != null && (
                          <div className="pc-pnl-item">
                            <span className="pc-trade-label">Closed At</span>
                            <span className="pc-pnl-value">
                              ${fmt(t.closedPrice)}
                            </span>
                          </div>
                        )}
                        {t.pnl != null && (
                          <div className="pc-pnl-item">
                            <span className="pc-trade-label">PNL</span>
                            <span
                              className={`pc-pnl-value ${t.pnl >= 0 ? "pc-green" : "pc-red"}`}
                            >
                              {t.pnl >= 0 ? "+" : ""}
                              {fmt(t.pnl)} USD
                            </span>
                          </div>
                        )}
                        {t.pnlPercent != null && (
                          <div className="pc-pnl-item">
                            <span className="pc-trade-label">ROI</span>
                            <span
                              className={`pc-pnl-value ${t.pnlPercent >= 0 ? "pc-green" : "pc-red"}`}
                            >
                              {t.pnlPercent >= 0 ? "+" : ""}
                              {t.pnlPercent}%
                            </span>
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  {/* Close reason */}
                  {t.closeReason && (
                    <div className="pc-trade-note">{t.closeReason}</div>
                  )}
                </div>

                {t.description && (
                  <div className="desc">
                    <div dangerouslySetInnerHTML={{ __html: t.description }} />
                  </div>
                )}

                <div className="desc" style={{ marginTop: "auto" }}>
                  <div className="date">{moment(t.createdAt).fromNow()}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {noOfPost > limit && (
        <div className="d-flex justify-content-center">
          <Stack spacing={2}>
            <Pagination
              count={Math.ceil(noOfPost / limit)}
              page={page}
              onChange={handleChange}
            />
          </Stack>
        </div>
      )}
    </div>
  );
};

const StocksComp = ({ handleActiveImg }) => {
  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);

  const getPosts = async () => {
    try {
      let payload = {
        page: page,
        userId: userStore?.users?.user?._id,
      };
      setLoader(true);
      const postData = await api.stocksGet(payload);
      // console.log(postData);
      // setData([...data, ...postData.post]);
      setData(postData.post);
      setnoOfPost(postData.count);
      setLimit(postData.limit);
      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "Something went wrong");
      console.log(error?.message);
      setLoader(false);
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
    var scrollDiv = document.getElementById("cWidget").offsetTop;
    window.scrollTo({ top: scrollDiv, behavior: "smooth" });
  };

  useEffect(() => {
    getPosts();
  }, [page]);

  return (
    <>
      <div className="userPostSec">
        {data.length == 0 && !loader && (
          <h3 className="text-center mt-4">No Data Available</h3>
        )}

        <div className="row">
          {data.map((item, key) => (
            <>
              <StockCardComp
                item={item}
                key={key}
                handleActiveImg={handleActiveImg}
              />
            </>
          ))}
        </div>
      </div>
      {/* {limit * page < noOfPost && (
        <div className="showMoreBtn text-center mt-5">
          <button
            className="themeBtn mx-auto"
            onClick={() => handleChange(page + 1)}
          >
            Show More
          </button>
        </div>
      )} */}
      <div className="d-flex justify-content-center">
        <Stack spacing={2}>
          <Pagination
            count={Math.ceil(noOfPost / limit)}
            page={page}
            onChange={handleChange}
          />
        </Stack>
      </div>
    </>
  );
};
const MarketComp = ({ handleActiveImg }) => {
  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);

  const getPosts = async () => {
    try {
      let payload = {
        page: page,
        userId: userStore?.users?.user?._id,
      };
      setLoader(true);
      const postData = await api.martketUpdateGet(payload);
      // console.log(postData);
      // setData([...data, ...postData.post]); //showmore to merge previous data
      setData(postData.post);
      setnoOfPost(postData.count);
      setLimit(postData.limit);
      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "Something went wrong");
      console.log(error?.message);
      setLoader(false);
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
    var scrollDiv = document.getElementById("cWidget").offsetTop;
    window.scrollTo({ top: scrollDiv, behavior: "smooth" });
  };

  useEffect(() => {
    getPosts();
  }, [page]);

  return (
    <>
      <div className="userPostSec">
        {data.length == 0 && !loader && (
          <h3 className="text-center mt-4">No Data Available</h3>
        )}

        <div className="row">
          {data.map((item, key) => (
            <PostCardMarket
              item={item}
              key={key}
              handleActiveImg={handleActiveImg}
            />
          ))}
        </div>
      </div>
      {/* {limit * page < noOfPost && (
        <div className="showMoreBtn text-center mt-5">
          <button
            className="themeBtn mx-auto"
            onClick={() => handleChange(page + 1)}
          >
            Show More
          </button>
        </div>
      )} */}
      <div className="d-flex justify-content-center">
        <Stack spacing={2}>
          <Pagination
            count={Math.ceil(noOfPost / limit)}
            page={page}
            onChange={handleChange}
          />
        </Stack>
      </div>
    </>
  );
};

const PostCardMarket = ({ item, key, handleActiveImg }) => {
  const userStore = useSelector((state) => state.userReducer);
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const [userReacted, setUserReacted] = useState({});
  const [allReactions, setAllReactions] = useState([]);

  const [reactionCounts, setReactionCounts] = useState({});

  const addReaction = async (reactionType) => {
    try {
      let payload = {
        userId: userStore?.users?.user?._id,
        postId: item?._id,
        reactionType: reactionType,
      };
      if (userReacted?.reactionType == reactionType) {
        console.log("already reacted");
        return;
      }

      const resp = await api.marketReactionAdd(payload);
      // console.log(resp);
      if (resp?.reaction?.userId) {
        // getReaction(item?._id);
        // Update the local state to reflect the new reaction count and the user's reaction
        setReactionCounts((prevCounts) => {
          const updatedCounts = { ...prevCounts };
          // If there's an existing reaction, decrement its count
          if (userReacted?.reactionType) {
            updatedCounts[userReacted?.reactionType] = Math.max(
              0,
              updatedCounts[userReacted?.reactionType] - 1,
            );
          }
          // Increment the count for the new reaction type
          updatedCounts[reactionType] = (updatedCounts[reactionType] || 0) + 1;

          return updatedCounts;
        });
        setUserReacted(resp?.reaction);
      }
    } catch (error) {}
  };
  const deleteReaction = async (id, reactionType) => {
    try {
      let payload = {
        id: id,
        reactionType: reactionType,
        postId: item?._id,
      };
      // console.log(payload);

      const resp = await api.marketReactionDelete(payload);
      // console.log(resp);
      if (resp?.message == "Reaction deleted") {
        // Update the local state to reflect the removed reaction
        setReactionCounts((prevCounts) => {
          const updatedCounts = { ...prevCounts };
          if (updatedCounts[reactionType]) {
            updatedCounts[reactionType] -= 1;
          }
          return updatedCounts;
        });
        setUserReacted({});
        // getReaction(item?._id);
      }
    } catch (error) {
      console.log(error?.message);
    }
  };

  useEffect(() => {
    if (item?.reactionCount) {
      setReactionCounts(item?.reactionCount || {});
    }
  }, []);

  return (
    <div className="col-12 mb-3" key={key}>
      <div className="postCard">
        {item?.imageTitle && (
          <>
            {item.imageTitle.split(",").length > 1 ? (
              <Slider {...settings}>
                {item.imageTitle.split(",").map((val, key) => (
                  <div>
                    <div
                      className="imgDiv"
                      onClick={() =>
                        handleActiveImg(
                          `${process.env.REACT_APP_S3URL}/img_${val}.${
                            item.imageFormat.split(",")[key]
                          }`,
                        )
                      }
                    >
                      <img
                        src={`${process.env.REACT_APP_S3URL}/img_${val}.${
                          item.imageFormat.split(",")[key]
                        }`}
                        alt=""
                      />
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <>
                {item.imageTitle.split(",").map((val, key) => (
                  <div
                    className="imgDiv"
                    onClick={() =>
                      handleActiveImg(
                        `${process.env.REACT_APP_S3URL}/img_${val}.${
                          item.imageFormat.split(",")[key]
                        }`,
                      )
                    }
                  >
                    <img
                      src={`${process.env.REACT_APP_S3URL}/img_${val}.${
                        item.imageFormat.split(",")[key]
                      }`}
                      alt=""
                    />
                  </div>
                ))}
              </>
            )}
          </>
        )}
        {item?.video && (
          <div className="py-2 iVideoPost">
            <div
              dangerouslySetInnerHTML={{
                __html: item?.video,
              }}
            />
          </div>
        )}
        {item?.pdfFile && (
          <div>
            <a
              href={`${process.env.REACT_APP_S3URL}/${item?.pdfFile}`}
              download={item?.pdfFile.split("_")[0]}
              target="_blank"
              className="fileAttachCard my-2"
            >
              <span className="fileAttachIcon">
                {item?.pdfFile.includes(".pdf") ? (
                  <i
                    className="fa-solid fa-file-pdf"
                    style={{ color: "#e53935" }}
                  />
                ) : item?.pdfFile.includes(".xlsx") ||
                  item?.pdfFile.includes(".xls") ? (
                  <i
                    className="fa-solid fa-file-excel"
                    style={{ color: "#1d6f42" }}
                  />
                ) : (
                  <i
                    className="fas fa-file-word"
                    style={{ color: "#1565c0" }}
                  />
                )}
              </span>
              <span className="fileAttachName">
                {item?.pdfFile.split("_")[0]}
              </span>
            </a>
          </div>
        )}
        <div className="desc">
          <div
            dangerouslySetInnerHTML={{
              __html: item?.description,
            }}
          />
          <div className="date"> {moment(item?.createdAt).fromNow()}</div>
        </div>
        {item?.voice && (
          <div className="audio my-2">
            <audio controls controlsList="nodownload" className="w-100">
              <source
                src={`${process.env.REACT_APP_S3URLVoice}/${item.voice}`}
              />
              Audio element not supported by your browser.
            </audio>
          </div>
        )}
        {/* <ReactionsMain
          post={item}
          addReaction={addReaction}
          deleteReaction={deleteReaction}
          setUserReacted={setUserReacted}
          userReacted={userReacted}
        />
        <div className="statesRow">
          <div className="statsR">
            {Object.keys(reactionCounts).map(
              (reactionType) =>
                reactionCounts[reactionType] > 0 && (
                  <div className="stats">
                    {reactionType == "like" ||
                    reactionType == "love" ||
                    reactionType == "sad" ? (
                      <img
                        src={`${baseUrl}/emogis/${reactionType}.png`}
                        alt="icon"
                      />
                    ) : (
                      <img
                        src={`https://flagcdn.com/w20/${reactionType.toLowerCase()}.png`}
                        alt="icon"
                      />
                    )}
                    {reactionCounts[reactionType]}
                  </div>
                )
            )}
          </div>
          <div className="date"> {moment(item?.createdAt).fromNow()}</div>
        </div> */}
      </div>
    </div>
  );
};
const PostCardVideo = ({ item, key }) => {
  const userStore = useSelector((state) => state.userReducer);
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const [playing, setPlaying] = useState(false);
  const [userReacted, setUserReacted] = useState({});
  const [allReactions, setAllReactions] = useState([]);

  const [reactionCounts, setReactionCounts] = useState({});

  const addReaction = async (reactionType) => {
    try {
      let payload = {
        userId: userStore?.users?.user?._id,
        postId: item?._id,
        reactionType: reactionType,
      };
      if (userReacted?.reactionType == reactionType) {
        console.log("already reacted");
        return;
      }

      const resp = await api.educationReactionAdd(payload);
      // console.log(resp);
      if (resp?.reaction?.userId) {
        // getReaction(item?._id);
        // Update the local state to reflect the new reaction count and the user's reaction
        setReactionCounts((prevCounts) => {
          const updatedCounts = { ...prevCounts };
          // If there's an existing reaction, decrement its count
          if (userReacted?.reactionType) {
            updatedCounts[userReacted?.reactionType] = Math.max(
              0,
              updatedCounts[userReacted?.reactionType] - 1,
            );
          }
          // Increment the count for the new reaction type
          updatedCounts[reactionType] = (updatedCounts[reactionType] || 0) + 1;

          return updatedCounts;
        });
        setUserReacted(resp?.reaction);
      }
    } catch (error) {}
  };
  const deleteReaction = async (id, reactionType) => {
    try {
      let payload = {
        id: id,
        reactionType: reactionType,
        postId: item?._id,
      };
      // console.log(payload);

      const resp = await api.educationReactionDelete(payload);
      // console.log(resp);
      if (resp?.message == "Reaction deleted") {
        // Update the local state to reflect the removed reaction
        setReactionCounts((prevCounts) => {
          const updatedCounts = { ...prevCounts };
          if (updatedCounts[reactionType]) {
            updatedCounts[reactionType] -= 1;
          }
          return updatedCounts;
        });
        setUserReacted({});
        // getReaction(item?._id);
      }
    } catch (error) {
      console.log(error?.message);
    }
  };

  useEffect(() => {
    if (item?.reactionCount) {
      setReactionCounts(item?.reactionCount || {});
    }
  }, []);

  return (
    <div className="masgM" key={key}>
      {item?.video && (
        <div className="msg">
          {!playing ? (
            <div
              onClick={() => setPlaying(true)}
              style={{
                width: "100%",
                paddingBottom: "56.25%",
                position: "relative",
                backgroundColor: "#111111",
                cursor: "pointer",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%",
                    background: "var(--theme-gradient)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 12,
                    boxShadow: "0 4px 15px 0 rgba(116,79,168,0.5)",
                  }}
                >
                  <i
                    className="fa-solid fa-play"
                    style={{ color: "#fff", fontSize: 22, marginLeft: 3 }}
                  />
                </div>
                <span
                  style={{
                    fontSize: 13,
                    color: "rgba(245,245,245,0.5)",
                    letterSpacing: "0.5px",
                  }}
                >
                  Click To Watch
                </span>
              </div>
            </div>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: item?.video }} />
          )}
        </div>
      )}
      {item?.pdfFile && (
        <div>
          <a
            href={`${process.env.REACT_APP_S3URL}/${item?.pdfFile}`}
            download={item?.pdfFile.split("_")[0]}
            target="_blank"
            className="fileAttachCard my-2"
          >
            <span className="fileAttachIcon">
              {item?.pdfFile.includes(".pdf") ? (
                <i
                  className="fa-solid fa-file-pdf"
                  style={{ color: "#e53935" }}
                />
              ) : item?.pdfFile.includes(".xlsx") ||
                item?.pdfFile.includes(".xls") ? (
                <i
                  className="fa-solid fa-file-excel"
                  style={{ color: "#1d6f42" }}
                />
              ) : (
                <i className="fas fa-file-word" style={{ color: "#1565c0" }} />
              )}
            </span>
            <span className="fileAttachName">
              {item?.pdfFile.split("_")[0]}
            </span>
          </a>
        </div>
      )}
      {item?.title && (
        <div className="msg">
          {item?.title && (
            <div className="title" style={{ fontWeight: 500 }}>
              {item?.title}
            </div>
          )}
        </div>
      )}
      {item?.description && (
        <div className="desc mb-2">
          <div
            dangerouslySetInnerHTML={{
              __html: item?.description,
            }}
          />
        </div>
      )}
      <div className="date"> {moment(item?.createdAt).fromNow()}</div>

      {/* <ReactionsMain
        post={item}
        addReaction={addReaction}
        deleteReaction={deleteReaction}
        setUserReacted={setUserReacted}
        userReacted={userReacted}
      />
      <div className="statesRow">
        <div className="statsR">
          {Object.keys(reactionCounts).map(
            (reactionType) =>
              reactionCounts[reactionType] > 0 && (
                <div className="stats">
                  {reactionType == "like" ||
                  reactionType == "love" ||
                  reactionType == "sad" ? (
                    <img
                      src={`${baseUrl}/emogis/${reactionType}.png`}
                      alt="icon"
                    />
                  ) : (
                    <img
                      src={`https://flagcdn.com/w20/${reactionType.toLowerCase()}.png`}
                      alt="icon"
                    />
                  )}
                  {reactionCounts[reactionType]}
                </div>
              )
          )}
        </div>
        <div className="date"> {moment(item?.createdAt).fromNow()}</div>
      </div> */}
    </div>
  );
};
const LiveSessionLinkCard = ({ item, key, sessionData }) => {
  const userStore = useSelector((state) => state.userReducer);

  const [userReacted, setUserReacted] = useState({});
  const [allReactions, setAllReactions] = useState([]);

  const [reactionCounts, setReactionCounts] = useState({});

  const addReaction = async (reactionType) => {
    try {
      let payload = {
        userId: userStore?.users?.user?._id,
        postId: item?._id,
        reactionType: reactionType,
      };
      if (userReacted?.reactionType == reactionType) {
        console.log("already reacted");
        return;
      }

      const resp = await api.educationReactionAdd(payload);
      // console.log(resp);
      if (resp?.reaction?.userId) {
        // getReaction(item?._id);
        // Update the local state to reflect the new reaction count and the user's reaction
        setReactionCounts((prevCounts) => {
          const updatedCounts = { ...prevCounts };
          // If there's an existing reaction, decrement its count
          if (userReacted?.reactionType) {
            updatedCounts[userReacted?.reactionType] = Math.max(
              0,
              updatedCounts[userReacted?.reactionType] - 1,
            );
          }
          // Increment the count for the new reaction type
          updatedCounts[reactionType] = (updatedCounts[reactionType] || 0) + 1;

          return updatedCounts;
        });
        setUserReacted(resp?.reaction);
      }
    } catch (error) {}
  };
  const deleteReaction = async (id, reactionType) => {
    try {
      let payload = {
        id: id,
        reactionType: reactionType,
        postId: item?._id,
      };
      // console.log(payload);

      const resp = await api.educationReactionDelete(payload);
      // console.log(resp);
      if (resp?.message == "Reaction deleted") {
        // Update the local state to reflect the removed reaction
        setReactionCounts((prevCounts) => {
          const updatedCounts = { ...prevCounts };
          if (updatedCounts[reactionType]) {
            updatedCounts[reactionType] -= 1;
          }
          return updatedCounts;
        });
        setUserReacted({});
        // getReaction(item?._id);
      }
    } catch (error) {
      console.log(error?.message);
    }
  };

  useEffect(() => {
    if (item?.reactionCount) {
      setReactionCounts(item?.reactionCount || {});
    }
  }, []);

  return (
    <div className=" sessionCard" key={key}>
      <CountdownTimer
        link={item?.link}
        eventTime={item?.eventTime}
        sessionId={item?._id}
        isEnded={item?.isEnded}
        sessionData={sessionData}
      />

      {item?.title && (
        <div className="msg">
          {item?.title && (
            <div className="title" style={{ fontWeight: 500 }}>
              {item?.title}
            </div>
          )}
        </div>
      )}

      <div className="date"> {moment(item?.createdAt).fromNow()}</div>
    </div>
  );
};

const Storycomp = () => {
  const storylyRef = useRef();
  useLayoutEffect(() => {
    storylyRef.current.init({
      token:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NfaWQiOjE0MDEwLCJhcHBfaWQiOjIxNjAwLCJpbnNfaWQiOjI0MzQyfQ.Q8zpWP6OhkeiyW3_YMbrLyLxxpXKcdgKHd89p8f-bCY",
    });
  }, []);
  return (
    <>
      <div className="mt-4">
        <storyly-web ref={storylyRef} />
      </div>
    </>
  );
};

// const GodzillaComp = ({ handleActiveImg }) => {
//   const navigate = useNavigate();
//   const alert = useAlert();
//   const userStore = useSelector((state) => state.userReducer);
//   const user = userStore?.users?.user;
//   const onboardingStatus =
//     user?.continueWithoutCourse || user?.demoTradingUnlocked
//       ? "unlocked"
//       : "gate";

//   const [loader, setLoader] = useState(false);
//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);
//   const [data, setData] = useState([]);
//   const [noOfPost, setnoOfPost] = useState(0);
//   const baseUrl = `${window.location.protocol}//${window.location.host}`;

//   const [show, setShow] = useState(false);
//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   const getLiveData = async () => {
//     try {
//       setLoader(true);
//       let payload = {
//         page: page,
//       };
//       const resp = await api.getGodzillaByUser(payload);
//       // console.log(resp);
//       if (resp?.success) {
//         setData(resp?.trades || []);
//         setnoOfPost(resp.total);
//         setLimit(resp.limit);
//         setLoader(false);
//       }
//       setLoader(false);
//     } catch (error) {
//       alert.show(error?.message || "Something went wrong");
//       console.log(error?.message);
//       setLoader(false);
//     }
//   };

//   const handleChange = (event, value) => {
//     setPage(value);
//   };

//   useEffect(() => {
//     if (onboardingStatus === "unlocked") {
//       getLiveData();
//     }
//   }, [page, onboardingStatus]);

//   const handleImageError = (event) => {
//     event.target.src = `${baseUrl}/icon-not-found.png`;
//     event.target.onerror = null;
//     event.target.alt = "Not Found";
//   };

//   useEffect(() => {
//     const socket = io(
//       process.env.REACT_APP_SOCKET_INSTANCE_URL || "http://localhost:4000",
//     );

//     socket.on("newTradeAlert", (data) => {
//       handleShow();
//       setTimeout(() => {
//         if (page != 1) {
//           setPage(1);
//         } else {
//           getLiveData();
//         }
//       }, 3000);
//     });

//     return () => socket.disconnect(); // Cleanup on unmount
//   }, []);

//   const normalizeDecimal = (value) => {
//     const num = parseFloat(value);
//     if (isNaN(num)) return "0.00";
//     if (num >= 1) {
//       return Number(num.toFixed(3)).toString();
//     }
//     return Number(num.toFixed(5)).toString();
//   };

//   return (
//     <>
//       <div className="userPostSec">
//         {/* ── Onboarding gate ── */}
//         {onboardingStatus === "loading" && <Loader />}
//         {onboardingStatus === "gate" && (
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               minHeight: 340,
//               textAlign: "center",
//               padding: "48px 24px",
//             }}
//           >
//             <div
//               style={{
//                 width: 72,
//                 height: 72,
//                 borderRadius: 22,
//                 background: "linear-gradient(135deg,#a78bfa,#7c3aed)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: 32,
//                 marginBottom: 24,
//                 boxShadow: "0 16px 40px rgba(124,61,237,.4)",
//               }}
//             >
//               🎓
//             </div>
//             <h2
//               style={{
//                 margin: "0 0 10px",
//                 fontWeight: 800,
//                 fontSize: 22,
//                 color: "#141020",
//               }}
//             >
//               Complete Onboarding to Access Futures
//             </h2>
//             <p
//               style={{
//                 margin: "0 0 28px",
//                 color: "#6a6580",
//                 fontSize: 15,
//                 maxWidth: 420,
//                 lineHeight: 1.6,
//               }}
//             >
//               Please complete the onboarding process to see Waqar Zaka Futures
//               signals.
//             </p>
//             <button
//               onClick={() => navigate("/onboarding-course")}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 10,
//                 fontSize: 15,
//                 fontWeight: 800,
//                 letterSpacing: ".05em",
//                 textTransform: "uppercase",
//                 color: "#fff",
//                 border: "none",
//                 cursor: "pointer",
//                 padding: "16px 32px",
//                 borderRadius: 14,
//                 background:
//                   "linear-gradient(135deg,#8b5cf6,#6d28d9 55%,#4c1d95)",
//                 boxShadow: "0 14px 36px rgba(124,61,237,.42)",
//               }}
//             >
//               Start Onboarding →
//             </button>
//           </div>
//         )}
//         {/* ── Trades feed (unlocked) ── */}
//         {onboardingStatus === "unlocked" && (
//           <>
//             <div className="notice">
//               <AlertCircleIcon />
//               <span>DO NOT COPY OLD TRADES</span>
//             </div>
//             <div className="row">
//               {data.map((item, key) => (
//                 <div className="col-md-6 mb-3" key={key}>
//                   <div className="liveTradeCard">
//                     <div className="r1">
//                       {item?.coin && (
//                         <div className="col1">
//                           {item?.coin && (
//                             <div className="icon">
//                               <img
//                                 src={`${baseUrl}/icon/${item?.coin.toLowerCase().split("/")[0]}.svg`}
//                                 alt="coin"
//                                 onError={(e) => handleImageError(e)}
//                               />
//                             </div>
//                           )}
//                           <div className="coin">{item?.coin}</div>
//                           <div
//                             className={
//                               item?.position == "LONG"
//                                 ? "position long"
//                                 : "position short"
//                             }
//                           >
//                             {item?.position}
//                             {item?.position == "LONG" ? (
//                               <FaArrowTrendUp />
//                             ) : (
//                               <FaArrowTrendDown />
//                             )}
//                           </div>
//                         </div>
//                       )}
//                       <div className="d-flex align-items-center gap-2 ms-auto flex-wrap">
//                         {item?.status && (
//                           <span
//                             style={{
//                               fontSize: 11,
//                               fontWeight: 600,
//                               padding: "2px 8px",
//                               borderRadius: 6,
//                               background:
//                                 item.status === "CLOSED"
//                                   ? "#6c757d"
//                                   : "#198754",
//                               color: "#fff",
//                             }}
//                           >
//                             {item.status}
//                           </span>
//                         )}
//                         <div className="dateLive">
//                           {moment(item?.createdAt).fromNow()}
//                         </div>
//                       </div>
//                     </div>
//                     {/* {item?.video && item?.image && (
//                           <div className="videorow">
//                             {item?.video && (
//                               <div className="msg">
//                                 <div
//                                   dangerouslySetInnerHTML={{
//                                     __html: item?.video,
//                                   }}
//                                 />
//                               </div>
//                             )}
//                           </div>
//                         )} */}

//                     <div className="contentRow">
//                       <div className="col1">
//                         {item?.entryPrice && (
//                           <div className="list">
//                             <div className="items">
//                               Entry Price: $
//                               <span>
//                                 {/* {normalizeDecimal(item?.entryPrice)} */}
//                                 {item?.entryPrice}
//                               </span>
//                             </div>
//                             <div className="items">
//                               Take Profit: $
//                               <span>
//                                 {/* {normalizeDecimal(item?.targetPrice)} */}
//                                 {item?.targetPrice}
//                               </span>
//                             </div>
//                             {item?.stopLoss ? (
//                               <div className="items">
//                                 Stop Loss: $
//                                 <span>
//                                   {/* {normalizeDecimal(item?.stopLoss)} */}
//                                   {item?.stopLoss}
//                                 </span>
//                               </div>
//                             ) : (
//                               ""
//                             )}
//                           </div>
//                         )}
//                         {item?.voice && (
//                           <div className="audio">
//                             {/* <audio controls controlsList="nodownload">
//                                   <source src={`${item.voice}`}  />
//                                   Audio element not supported by your browser.
//                                 </audio> */}
//                             <AudioPlayer
//                               src={item.voice}
//                               showJumpControls={true} // forward/backward 30s buttons
//                               showSkipControls={false}
//                               autoPlay={false}
//                               autoPlayAfterSrcChange={false}
//                               onPlay={() => console.log("playing")}
//                             />
//                           </div>
//                         )}
//                         <div className="warning">
//                           <span>Warning:</span> Check your margin before opening
//                           a trade. if liquidation is near, do not enter. Reduce
//                           your margin and avoid old trade.
//                         </div>
//                       </div>
//                       {/* {(item?.image || item?.video) && (
//                             <div className="col2">
//                               {item?.image ? (
//                                 <div
//                                   className="imgDiv"
//                                   onClick={() =>
//                                     handleActiveImg(`${item.image}`)
//                                   }
//                                 >
//                                   <img src={`${item.image}`} alt="" />
//                                 </div>
//                               ) : item?.video ? (
//                                 <div className="msg">
//                                   <div
//                                     dangerouslySetInnerHTML={{
//                                       __html: item?.video,
//                                     }}
//                                   />
//                                 </div>
//                               ) : (
//                                 ""
//                               )}
//                             </div>
//                           )} */}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//             <div className="d-flex justify-content-center">
//               <Stack spacing={2}>
//                 <Pagination
//                   count={Math.ceil(noOfPost / limit)}
//                   page={page}
//                   onChange={handleChange}
//                 />
//               </Stack>
//             </div>
//           </> /* end unlocked */
//         )}{" "}
//         {/* end onboardingStatus === "unlocked" */}
//       </div>
//       <TextPopupModal
//         show={show}
//         handleClose={handleClose}
//         text="New Trade Added, Let's Check New Waqar Zaka Trade."
//       />
//       {loader && <Loader />}
//     </>
//   );
// };

const GodzillaComp = ({ handleActiveImg }) => {
  const userStore = useSelector((state) => state.userReducer);
  const { setUser } = userAction;
  const dispatch = useDispatch();

  const [signature, setSignature] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [loader, setLoader] = useState(false);
  const [vLoader, setVLoader] = useState(false);
  const [mLoader, setMLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  const [UID, setUID] = useState("");
  const [mexcUID, setMexcUID] = useState("");

  const alert = useAlert();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const submitSign = async () => {
    try {
      if (!signature) {
        alert.show("Signature is required.");
        return;
      }
      let payload = {
        godzillaSign: signature,
      };
      const resp = await api.addGodzillaConsents(payload);
      // console.log(resp);
      if (resp?.success) {
        setFormSubmitted(true);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "Something went wrong");
      console.log(error?.message);
      setLoader(false);
    }
  };

  const getSign = async () => {
    try {
      setLoader(true);
      const resp = await api.getGodzillaConsents();
      // console.log(resp);
      if (resp?.success) {
        setFormSubmitted(true);
      }
      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "Something went wrong");
      console.log(error?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getSign();
  }, []);

  const getLiveData = async () => {
    try {
      setLoader(true);
      let payload = {
        page: page,
      };
      const resp = await api.futureTradeGetUser(payload);
      // console.log(resp);
      if (resp?.success) {
        setData(resp?.trades || []);
        setnoOfPost(resp.total);
        setLimit(resp.limit);
        setLoader(false);
      }
      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "Something went wrong");
      console.log(error?.message);
      setLoader(false);
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (
      formSubmitted &&
      (userStore?.users?.user?.isWeexQualify ||
        userStore?.users?.user?.isMexcQualify)
    ) {
      getLiveData();
    }
  }, [
    page,
    formSubmitted,
    userStore?.users?.user?.isWeexQualify,
    userStore?.users?.user?.isMexcQualify,
  ]);

  const handleImageError = (event) => {
    event.target.src = `${baseUrl}/icon-not-found.png`;
    event.target.onerror = null;
    event.target.alt = "Not Found";
  };

  useEffect(() => {
    const socket = io(
      process.env.REACT_APP_SOCKET_INSTANCE_URL || "http://localhost:4000",
    );

    socket.on("newTradeAlert", (data) => {
      handleShow();
      setTimeout(() => {
        if (page != 1) {
          setPage(1);
        } else {
          getLiveData();
        }
      }, 3000);
    });

    return () => socket.disconnect(); // Cleanup on unmount
  }, []);

  const normalizeDecimal = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return "0.00";
    if (num >= 1) {
      return Number(num.toFixed(3)).toString();
    }
    return Number(num.toFixed(5)).toString();
  };

  const checkExchangeBalance = async () => {
    try {
      setVLoader(true);
      if (!UID) {
        alert.show("UID is required.");
        setVLoader(false);
        return;
      }
      setVLoader(true);
      if (UID.length > 30) {
        alert.show("Invalid UID.");
        setVLoader(false);
        return;
      }
      let payload = {
        UID,
      };
      const resp = await api.verifyGodzillaBalance(payload);
      // console.log(resp);
      if (resp?.success && resp?.isWeexQualify) {
        let updatedData = userStore?.users;
        updatedData.user.weex_UID = resp?.weex_UID;
        updatedData.user.isWeexQualify = resp?.isWeexQualify;
        dispatch(setUser(updatedData));
      }
      setVLoader(false);
    } catch (error) {
      alert.show(error?.message);
      setVLoader(false);
    }
  };

  const checkExchangeBalanceMexc = async () => {
    try {
      setMLoader(true);
      if (!mexcUID) {
        alert.show("UID is required.");
        setMLoader(false);
        return;
      }
      setMLoader(true);
      if (mexcUID.length > 30) {
        alert.show("Invalid UID.");
        setMLoader(false);

        return;
      }
      let payload = {
        UID: mexcUID,
      };
      const resp = await api.verifyGodzillaMexc(payload);
      // console.log(resp);
      if (resp?.success && resp?.isMexcQualify) {
        let updatedData = userStore?.users;
        updatedData.user.mexc_UID = resp?.uid;
        updatedData.user.isMexcQualify = resp?.isMexcQualify;
        dispatch(setUser(updatedData));
      }
      setMLoader(false);
    } catch (error) {
      alert.show(error?.message);
      setMLoader(false);
    }
  };

  return (
    <>
      <div className="userPostSec">
        {formSubmitted && (
          <>
            {userStore?.users?.user?.isWeexQualify ||
            userStore?.users?.user?.isMexcQualify ? (
              <>
                <div className="notice">
                  <AlertCircleIcon />
                  <span>DO NOT COPY OLD TRADES</span>
                </div>
                <div className="row">
                  {data.map((item, key) => (
                    <div className="col-md-6 mb-3" key={key}>
                      <div className="liveTradeCard">
                        <div className="r1">
                          {item?.coin && (
                            <div className="col1">
                              {item?.coin && (
                                <div className="icon">
                                  <img
                                    src={`${baseUrl}/icon/${item?.coin.toLowerCase().split("/")[0]}.svg`}
                                    alt="coin"
                                    onError={(e) => handleImageError(e)}
                                  />
                                </div>
                              )}
                              <div className="coin">{item?.coin}</div>
                              <div
                                className={
                                  item?.position == "LONG"
                                    ? "position long"
                                    : "position short"
                                }
                              >
                                {item?.position}
                                {item?.position == "LONG" ? (
                                  <FaArrowTrendUp />
                                ) : (
                                  <FaArrowTrendDown />
                                )}
                              </div>
                            </div>
                          )}
                          <div className="d-flex align-items-center gap-2 ms-auto flex-wrap">
                            {item?.status && (
                              <span
                                style={{
                                  fontSize: 11,
                                  fontWeight: 600,
                                  padding: "2px 8px",
                                  borderRadius: 6,
                                  background:
                                    item.status === "CLOSED"
                                      ? "#6c757d"
                                      : "#198754",
                                  color: "#fff",
                                }}
                              >
                                {item.status}
                              </span>
                            )}
                            <div className="dateLive">
                              {moment(item?.createdAt).fromNow()}
                            </div>
                          </div>
                        </div>
                        {/* {item?.video && item?.image && (
                          <div className="videorow">
                            {item?.video && (
                              <div className="msg">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item?.video,
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        )} */}

                        <div className="contentRow">
                          <div className="col1">
                            {item?.entryPrice && (
                              <div className="list">
                                <div className="items">
                                  Entry Price: $
                                  <span>
                                    {/* {normalizeDecimal(item?.entryPrice)} */}
                                    {item?.entryPrice}
                                  </span>
                                </div>
                                <div className="items">
                                  Take Profit: $
                                  <span>
                                    {/* {normalizeDecimal(item?.targetPrice)} */}
                                    {item?.targetPrice}
                                  </span>
                                </div>
                                {item?.stopLoss ? (
                                  <div className="items">
                                    Stop Loss: $
                                    <span>
                                      {/* {normalizeDecimal(item?.stopLoss)} */}
                                      {item?.stopLoss}
                                    </span>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            )}
                            {item?.voice && (
                              <div className="audio">
                                {/* <audio controls controlsList="nodownload">
                                  <source src={`${item.voice}`}  />
                                  Audio element not supported by your browser.
                                </audio> */}
                                <AudioPlayer
                                  src={item.voice}
                                  showJumpControls={true} // forward/backward 30s buttons
                                  showSkipControls={false}
                                  autoPlay={false}
                                  autoPlayAfterSrcChange={false}
                                  onPlay={() => console.log("playing")}
                                />
                              </div>
                            )}
                            <div className="warning">
                              <span>Warning:</span> Check your margin before
                              opening a trade. if liquidation is near, do not
                              enter. Reduce your margin and avoid old trade.
                            </div>
                          </div>
                          {/* {(item?.image || item?.video) && (
                            <div className="col2">
                              {item?.image ? (
                                <div
                                  className="imgDiv"
                                  onClick={() =>
                                    handleActiveImg(`${item.image}`)
                                  }
                                >
                                  <img src={`${item.image}`} alt="" />
                                </div>
                              ) : item?.video ? (
                                <div className="msg">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item?.video,
                                    }}
                                  />
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          )} */}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="d-flex justify-content-center">
                  <Stack spacing={2}>
                    <Pagination
                      count={Math.ceil(noOfPost / limit)}
                      page={page}
                      onChange={handleChange}
                    />
                  </Stack>
                </div>
              </>
            ) : (
              <GodzillaVerified
                checkExchangeBalance={checkExchangeBalance}
                checkExchangeBalanceMexc={checkExchangeBalanceMexc}
                vLoader={vLoader}
                mLoader={mLoader}
                setUID={setUID}
                setMexcUID={setMexcUID}
              />
            )}
          </>
        )}
        <div className="row">
          <div className="col mb-3">
            <div className="godzillaCard">
              {formSubmitted && (
                <>
                  {/* join exchanges destail */}
                  {/* <div className="gGroup">
                    <div className="heading">JOIN GODZILLA TRADING GROUPS</div>

                    <div className="optionCard">
                      <div className="titleRow">
                        <div className="title">Option 1: Via Weex Exchange</div>
                        <div className="themeBtn">Referral Code: z5je</div>
                      </div>
                      <div className="row ai-center">
                        <div className="col-md-8">
                          <div className="content">
                            <div className="text">
                              1. Create your WEEX account using the official
                              referral link:
                            </div>
                            <a
                              className="link"
                              href="https://support.weex.com/en/register?vipCode=z5je"
                              target="_blank"
                            >
                              https://support.weex.com/en/register?vipCode=z5je
                            </a>
                            <div className="text my-4">
                              2. Deposit at least 100 USDT into your Wallet.
                            </div>
                            <div className="text">
                              3. Get your UID (found in your Weex profile icon)
                              and verify via the bot here:
                            </div>
                            <a
                              className="link"
                              href="https://t.me/WaqarZaka_WEEX_Alpha_bot"
                              target="_blank"
                            >
                              https://t.me/WaqarZaka_WEEX_Alpha_bot
                            </a>
                            <div className="text mt-5">
                              Accounts not created with the referral code will
                              not be accepted.
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="imgDiv">
                            <img src={option2Img} alt="option1" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="optionCard">
                      <div className="titleRow">
                        <div className="title">
                          Option 2: Via Blofin Exchange
                        </div>
                        <div className="themeBtn">
                          Referral Code: teamwaqarzaka
                        </div>
                      </div>
                      <div className="row ai-center">
                        <div className="col-md-8">
                          <div className="content">
                            <div className="text">
                              1. Sign up on Blofin using this referral link:
                            </div>
                            <a
                              className="link"
                              href="https://partner.blofin.com/d/TeamWaqarZaka"
                              target="_blank"
                            >
                              https://partner.blofin.com/d/TeamWaqarZaka
                            </a>
                            <div className="text">
                              2. Deposit at least 100 USDT into your Futures
                              Wallet
                            </div>
                            <a
                              className="link"
                              href="https://blofin.com/invite/TeamWaqarZaka"
                              target="_blank"
                            >
                              https://blofin.com/invite/TeamWaqarZaka
                            </a>
                            <div className="text">
                              3. Go to the verification bot:
                            </div>
                            <a
                              className="link"
                              href="https://t.me/WaqarZaka_Blofin_Bot"
                            >
                              https://t.me/WaqarZaka_Blofin_Bot
                            </a>
                            <div className="text mt-5">
                              Accounts not created with the referral code will
                              not be accepted
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="imgDiv">
                            <img src={option3Img} alt="option1" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="optionCard">
                      <div className="titleRow">
                        <div className="title">
                          Option 3: Via BYBIT Exchange
                        </div>
                        <div className="themeBtn">Referral Code: 148029</div>
                      </div>
                      <div className="row ai-center">
                        <div className="col-md-8">
                          <div className="content">
                            <div className="text">
                              1. Create your BYBIT account using the official
                              referral link:
                            </div>
                            <a
                              className="link"
                              href="https://partner.bybit.com/b/148029"
                              target="_blank"
                            >
                              https://partner.bybit.com/b/148029
                            </a>
                            <div className="text my-4">
                              2. Deposit at least 100 USDT into your Futures
                              Wallet (not Spot).
                            </div>
                            <div className="text">
                              3. Get your UID (found in your BYBIT profile icon)
                              and verify via the bot here:
                            </div>
                            <a
                              className="link"
                              href="https://t.me/godzilla_bybit_bot"
                              target="_blank"
                            >
                              https://t.me/godzilla_bybit_bot
                            </a>
                            <div className="text mt-5">
                              Accounts not created with the referral code will
                              not be accepted.
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="imgDiv">
                            <img src={option1Img} alt="option1" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="optionCard">
                      <div className="titleRow">
                        <div className="title">Option 4: Via MEXC Exchange</div>
                        <div className="themeBtn">Referral Code: 1YtSR</div>
                      </div>
                      <div className="row ai-center">
                        <div className="col-md-8">
                          <div className="content">
                            <div className="text">
                              1. Create your MEXC account using the official
                              referral link:
                            </div>
                            <a
                              className="link"
                              href="https://www.mexc.com/register?inviteCode=mexc-1YtSR"
                              target="_blank"
                            >
                              https://www.mexc.com/register?inviteCode=mexc-1YtSR
                            </a>
                            <div className="text my-4">
                              2. Deposit at least 100 USDT into your Futures
                              Wallet (not Spot).
                            </div>
                            <div className="text">
                              3. Get your UID (found in your MEXC profile icon)
                              and verify via the bot here:
                            </div>
                            <a
                              className="link"
                              href="https://t.me/WaqarZaka_Mexc_Bot"
                              target="_blank"
                            >
                              https://t.me/WaqarZaka_Mexc_Bot
                            </a>
                            <div className="text mt-5">
                              Accounts not created with the referral code will
                              not be accepted.
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="imgDiv">
                            <img src={option1Img} alt="option1" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </>
              )}

              {!formSubmitted && (
                <>
                  <div className="warningMain">
                    {formSubmitted ? (
                      <div className="heading">
                        You have acknowledged and agreed to all the stated
                        requirements and responsibilities.
                      </div>
                    ) : (
                      <div className="heading">
                        Important Warning Before Joining
                      </div>
                    )}
                    <ol>
                      <li>
                        Before you are accepted into the group, <br />
                        <b>
                          {" "}
                          you must complete at least 1 month of demo trading.
                        </b>
                        If you skip this step, you may end up losing your funds
                        entirely.
                      </li>
                      <li>
                        Even if you already know how to trade, <br />
                        <b>
                          {" "}
                          Watching all educational videos available on the Waqar
                          Zaka platform is mandatory.
                        </b>{" "}
                        These videos are designed to align you with our exact
                        strategy and trading mindset.
                      </li>
                      <li>
                        In the <b>Waqar Zaka Trading group</b>, Waqar Zaka
                        shares <b> his personal trades</b> — this is{" "}
                        <b> not a signal group.</b> He announces in real-time
                        whether he is entering a long or short position. Most
                        trades are closed within 15 to 20 minutes, although some
                        may run longer.
                      </li>
                      <li>
                        <b>
                          As soon as Waqar Zaka posts the first profit/loss
                          screenshot, you must immediately close your trade,
                        </b>{" "}
                        regardless of whether it is in profit or loss.
                      </li>
                    </ol>

                    <div className="riskCard">
                      <div className="heading">Risk & Capital Requirements</div>
                      <ul>
                        <li>
                          <b>
                            {" "}
                            You are fully responsible for managing your own
                            liquidation levels.
                          </b>
                        </li>
                        <li>
                          A minimum balance of <b>$200–$300</b> is recommended
                          in your Futures trading account.
                        </li>
                        <li>
                          If your account has <b>$100</b>, you must trade with a{" "}
                          <b>maximum margin of $1 per trade</b>. To repeat: with
                          $100, your trade size must be limited to $1 margin per
                          position.
                        </li>
                      </ul>
                    </div>
                    <div className="heading">
                      Important Warning Before Joining
                    </div>
                    <ol>
                      <li>
                        It is{" "}
                        <b>not possible for every trade to be profitable.</b>{" "}
                        Losses will occur, and you must be mentally prepared for
                        that.
                      </li>
                      <li>
                        If you do not follow <b>risk management</b>, you are
                        likely to face significant issues.
                      </li>
                    </ol>
                  </div>
                  <div className="signGodzi">
                    <p>
                      If you fully understand and agree to all the points above,
                      please sign below, please sign below with enter your name.
                    </p>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Signature..."
                      onChange={(e) => setSignature(e.target.value)}
                    />
                    <div className="yourS">Your Signature</div>
                    <button
                      className="themeBlackBtn text-center"
                      onClick={submitSign}
                    >
                      Submit
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <TextPopupModal
        show={show}
        handleClose={handleClose}
        text="New Trade Added, Let's Check New Waqar Zaka Trade."
      />
      {loader && <Loader />}
    </>
  );
};

const SummaryComp = () => {
  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);

  const getPosts = async () => {
    try {
      let payload = {
        page: page,
        userId: userStore?.users?.user?._id,
      };
      setLoader(true);
      const postData = await api.getUserSummary(payload);
      // console.log(postData);
      // setData([...data, ...postData.post]);
      setData(postData.post);
      setnoOfPost(postData.count);
      setLimit(postData.limit);
      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "Something went wrong");
      console.log(error?.message);
      setLoader(false);
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
    var scrollDiv = document.getElementById("cWidget").offsetTop;
    window.scrollTo({ top: scrollDiv, behavior: "smooth" });
  };

  useEffect(() => {
    getPosts();
  }, [page]);

  return (
    <>
      <div className="userPostSec">
        {data.length == 0 && !loader && (
          <h3 className="text-center mt-4">No Data Available</h3>
        )}

        <div className="row">
          {data.map((item, key) => (
            <div className="col-md-6 mb-3" key={key}>
              <div className="postCard">
                <div className="desc">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item?.summary,
                    }}
                  />
                  <div className="date">
                    {" "}
                    {moment(item?.createdAt).fromNow()}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="d-flex justify-content-center">
        <Stack spacing={2}>
          <Pagination
            count={Math.ceil(noOfPost / limit)}
            page={page}
            onChange={handleChange}
          />
        </Stack>
      </div>
    </>
  );
};

const UnpaidAlert = () => {
  return (
    <>
      <div className="subscriptionNav">
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Crypto Trades
        </div>
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Stock & Commodities Trades
        </div>
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Market Updates
        </div>
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Education
        </div>
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Trade Summary
        </div>
      </div>
      <div className="userPostSec position-relative">
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="postCard">
              <div className="imgDiv dummy">
                <img src={demoImg1} alt="" />
              </div>
              <div className="desc">
                <div>Type: Spot</div>
                <div>coin: sei/usdt</div>
                <div>buy: 0.29</div>
                <div>TP: 0.3</div>
                <div>SL: 0.285</div>
                <div className="date"> 15 minutes ago</div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="postCard">
              <div className="imgDiv dummy">
                <img src={demoImg1} alt="" />
              </div>
              <div className="desc">
                <div>Type: Spot</div>
                <div>coin: sei/usdt</div>
                <div>buy: 0.29</div>
                <div>TP: 0.3</div>
                <div>SL: 0.285</div>
                <div className="date"> 15 minutes ago</div>
              </div>
            </div>
          </div>
        </div>
        <div className="lockUnpaidMain">
          <div className="icon">
            <MdLock />
          </div>
          <div className="text">Only Visible to paid members</div>
          <div>
            <Link to={"/checkout"} className="themeBtn">
              Pay Now
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

const NotVerifiedEmail = ({ sendOtpMail }) => {
  return (
    <>
      <div className="subscriptionNav">
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Crypto Trades
        </div>
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Stock & Commodities Trades
        </div>
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Market Updates
        </div>
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Education
        </div>
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Trade Summary
        </div>
      </div>
      <div className="userPostSec position-relative">
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="postCard">
              <div className="imgDiv dummy">
                <img src={demoImg1} alt="" />
              </div>
              <div className="desc">
                <div>Type: Spot</div>
                <div>coin: sei/usdt</div>
                <div>buy: 0.29</div>
                <div>TP: 0.3</div>
                <div>SL: 0.285</div>
                <div className="date"> 15 minutes ago</div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="postCard">
              <div className="imgDiv dummy">
                <img src={demoImg1} alt="" />
              </div>
              <div className="desc">
                <div>Type: Spot</div>
                <div>coin: sei/usdt</div>
                <div>buy: 0.29</div>
                <div>TP: 0.3</div>
                <div>SL: 0.285</div>
                <div className="date"> 15 minutes ago</div>
              </div>
            </div>
          </div>
        </div>
        <div className="lockUnpaidMain">
          <div className="icon">
            <MdLock />
          </div>
          <div className="text">
            Only Visible to users, who have verified email
          </div>
          <div>
            <button className="themeBtn" onClick={sendOtpMail}>
              Verify Email
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
const GodzillaVerified = ({
  checkExchangeBalance,
  vLoader,
  mLoader,
  setUID,
  checkExchangeBalanceMexc,
  setMexcUID,
}) => {
  const [joinVia, setJoinVia] = useState("weex");
  return (
    <>
      <div className="userPostSec position-relative">
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="postCard">
              <div className="imgDiv dummy">
                <img src={demoImg1} alt="" />
              </div>
              <div className="desc">
                <div>Type: Spot</div>
                <div>coin: sei/usdt</div>
                <div>buy: 0.29</div>
                <div>TP: 0.3</div>
                <div>SL: 0.285</div>
                <div className="date"> 15 minutes ago</div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="postCard">
              <div className="imgDiv dummy">
                <img src={demoImg1} alt="" />
              </div>
              <div className="desc">
                <div>Type: Spot</div>
                <div>coin: sei/usdt</div>
                <div>buy: 0.29</div>
                <div>TP: 0.3</div>
                <div>SL: 0.285</div>
                <div className="date"> 15 minutes ago</div>
              </div>
            </div>
          </div>
        </div>
        <div className="lockUnpaidMain">
          <div className="icon">
            <MdLock />
          </div>
          <div className="text">
            To access Waqar Zaka Trades, verify your UID with a minimum of 100
            USDT.
            {/* <img
              src={weexIco}
              alt="weex"
              style={{ width: 35, margin: "0 7px " }}
            /> */}
          </div>
          <div className="text2">
            Register using{" "}
            <img
              src={weexIco}
              alt="weex"
              style={{ width: 30, margin: "0 7px " }}
              className="rounded-circle"
            />{" "}
            WEEX referral link:{" "}
            <a
              href="https://support.weex.com/en/register?vipCode=z5je"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click Here
            </a>
          </div>
          {/* <div className="text2">
            Register using{" "}
            <img
              src={mexcIco}
              alt="weex"
              style={{ width: 30, margin: "0 7px " }}
              className="rounded-circle"
            />{" "}
            MEXC referral link:{" "}
            <a
              href="https://www.mexc.com/register?inviteCode=mexc-1YtSR"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click Here
            </a>
          </div> */}
          <div className="text2 mt-2">
            Accounts without the referral code will not be accepted.
          </div>
          <div className="subscriptionNav mt-3">
            <div
              className={joinVia == "weex" ? "link active" : "link"}
              onClick={() => setJoinVia("weex")}
            >
              <img
                src={weexIco}
                alt="weex"
                style={{ width: 35, margin: "0 7px " }}
                className="rounded-circle"
              />{" "}
              Join Via Weex
            </div>
            {/* <div
              className={joinVia == "mexc" ? "link active" : "link"}
              onClick={() => setJoinVia("mexc")}
            >
              <img
                src={mexcwhiteIco}
                alt="weex"
                style={{ width: 35, margin: "0 7px " }}
                className="rounded-circle"
              />{" "}
              Join Via Mexc
            </div> */}
          </div>
          {joinVia == "weex" ? (
            <div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control mt-4"
                  onChange={(e) => setUID(e.target.value)}
                  placeholder="Enter Weex UID"
                />
              </div>
              <button
                className="themeBtn"
                onClick={checkExchangeBalance}
                disabled={vLoader}
              >
                {vLoader && (
                  <i
                    className="fa fa-spinner fa-pulse mx-2 mb-1"
                    style={{ position: "relative", top: "-0px" }}
                  ></i>
                )}
                Verify Weex UID
              </button>
            </div>
          ) : (
            <div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control mt-4"
                  onChange={(e) => setMexcUID(e.target.value)}
                  placeholder="Enter Mexc UID"
                />
              </div>
              <button
                className="themeBtn"
                onClick={checkExchangeBalanceMexc}
                disabled={mLoader}
              >
                {mLoader && (
                  <i
                    className="fa fa-spinner fa-pulse mx-2 mb-1"
                    style={{ position: "relative", top: "-0px" }}
                  ></i>
                )}
                Verify Mexc UID
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
const TermsComp = ({ setIsTermsAccepted }) => {
  const alert = useAlert();
  const [data, setData] = useState({});
  const [loader, setLoader] = useState(false);

  const accept = async () => {
    try {
      const validatorsResponse = validators();

      if (validatorsResponse) {
        return alert.show(validatorsResponse);
      }
      setLoader(true);
      const payload = {
        confirmAccount: data.confirmAccount,
        authCard: data.authCard,
        monthlySubscription: data.monthlysubs,
        renewAuto: data.renewAuto,
        nonRefund: data.nonRefund,
        aggreeTerms: data.aggreeTerms,
        understandMisuse: data.understandMisuse,
        unauthTransaction: data.unauthTransaction,
      };

      const response = await api.addSubscriptionConsents(payload);
      // console.log(response);
      if (response?.consent) {
        setIsTermsAccepted(true);
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      alert.show("Something went wrong");
      setLoader(false);
    }
  };

  const validators = () => {
    if (!data?.confirmAccount) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.authCard) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.monthlysubs) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.renewAuto) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.nonRefund) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.aggreeTerms) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.understandMisuse) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.unauthTransaction) {
      return "Kindly confirm each checkbox to proceed.";
    }
    return false;
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.checked });
  };
  return (
    <>
      <div className="subscriptionNav">
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Crypto Trades
        </div>
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Stock & Commodities Trades
        </div>
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Market Updates
        </div>
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Education
        </div>
        <div className={"link"}>
          <span style={{ fontSize: 18, marginRight: 5 }}>
            <MdLock />
          </span>
          Trade Summary
        </div>
      </div>
      <div className="userPostSec position-relative">
        <div className="showMoreModalM">
          <div className="showMoreModal ">
            <h4 className="my-3 text-center">
              Please accept terms, to access dashboard.
            </h4>
            <ol>
              <li className="py-2">
                <p className="desc1 ">
                  <input
                    type="checkbox"
                    name="confirmAccount"
                    className="me-2"
                    onChange={handleChange}
                  />
                  I confirm that I am the owner of this account.
                </p>
              </li>
              <li className="py-2">
                <p className="desc1 ">
                  <input
                    type="checkbox"
                    name="authCard"
                    className="me-2"
                    onChange={handleChange}
                  />
                  I confirm that I am using my own credit/debit card or have
                  authorized access to this card.
                </p>
              </li>
              <li className="py-2">
                <p className="desc1 ">
                  <input
                    type="checkbox"
                    name="monthlysubs"
                    className="me-2"
                    onChange={handleChange}
                  />
                  I authorize WaqarZaka.net to charge my card for a monthly
                  subscription.
                </p>
              </li>
              <li className="py-2">
                <p className="desc1 ">
                  <input
                    type="checkbox"
                    name="renewAuto"
                    className="me-2"
                    onChange={handleChange}
                  />
                  I understand that after my first month’s payment, my
                  subscription will automatically renew each month unless I
                  cancel it in advance.
                </p>
              </li>
              <li className="py-2">
                <p className="desc1 ">
                  <input
                    type="checkbox"
                    name="nonRefund"
                    className="me-2"
                    onChange={handleChange}
                  />
                  I understand this is a non-refundable digital subscription,
                  and after 12 hours of purchase, no refund requests will be
                  accepted.
                </p>
              </li>
              <li className="py-2">
                <p className="desc1 ">
                  <input
                    type="checkbox"
                    name="aggreeTerms"
                    className="me-2"
                    onChange={handleChange}
                  />
                  I agree to the platform’s{" "}
                  <Link to="/terms-and-conditions">Terms & Conditions</Link> and{" "}
                  <Link to="/privacy-policy"> Privacy Policy.</Link>
                </p>
              </li>
              <li className="py-2">
                <p className="desc1 ">
                  <input
                    type="checkbox"
                    name="understandMisuse"
                    className="me-2"
                    id=""
                    onChange={handleChange}
                  />
                  I understand that misuse, account sharing, or reselling
                  content may lead to account suspension without refund.
                </p>
              </li>
              <li className="py-2">
                <p className="desc1 ">
                  <input
                    type="checkbox"
                    name="unauthTransaction"
                    className="me-2"
                    onChange={handleChange}
                  />
                  I agree that any unauthorized or fraudulent activity may lead
                  to data disclosure, account suspension, and legal action.{" "}
                  <Link to={"/unauthorized-transaction"}>For more info</Link>
                </p>
              </li>
            </ol>
          </div>
          <div className="mt-4">
            <button
              className="themeBtn mx-auto"
              onClick={accept}
              disabled={loader}
            >
              {loader && (
                <i
                  className="fa fa-spinner fa-pulse mx-2 mb-1"
                  style={{ position: "relative", top: "-0px" }}
                ></i>
              )}
              Accept
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
